import { initStoragePolicyBanner } from "../../../scripts/storage-policy/storage-policy-modal.js";

angular.module('harriApp')
    .controller('GPCareerPortalController',
        [
            "$rootScope", "$scope", "$state", "$stateParams", "$location", "$filter", "DispatcherServices",
            "deviceChecker", "hUser", "JobDetailsBus", "jobApplyFactory", "hEvent", "CareerPortalDataBus", "$modal", "localize",
            "chatBotService", "$element", "$timeout", "brandServices", "googleMaps", 'accessibilityToolsService',
            "googleTagManagerTrackingService", 'appLayoutViewService', 'outmatchAssessmentService', function (
            $rootScope, $scope, $state, $stateParams, $location, $filter, DispatcherServices,
            deviceChecker, hUser, JobDetailsBus, jobApplyFactory, hEvent, CareerPortalDataBus, $modal,
            localize, chatBotService, $element, $timeout, brandServices, googleMaps, accessibilityToolsService,
            googleTagManagerTrackingService, appLayoutViewService, outmatchAssessmentService) {

            var hits;
            var requestLock = false;
            var mapRequestLock = false;
            var centerLat;
            var centerLng;
            var loadedJobs = 0;
            var backTo = [];
            var parentName = "";
            var enterpriseData = {
                name: null,
                active_jobs_count: 0,
                selected_child: null
            };
            $scope.showMapOnMobile = false;
            $scope.isInternalCareerPortal = false;
            $scope.allJobsSearchResult = [];
            $scope.map = {};
            $scope.selectedJobsForComparison = [];
            $scope.maxSelectedJobsForComparison = 5;
            $scope.isMobileView  = deviceChecker.isMobile() || deviceChecker.isTinyScreen();
            let talentScoutCodeId = $stateParams['talent_scout_code_id'];
            let utmSource = $stateParams['utm_source'];

            var jobApplyButtonsElms = [];
            const MAX_SEARCH_LIMIT = 10000;
            var slideIndex = 0;
            var simpleViewSlideIndex = 0;
            var slideInterval;
            var simpleViewSlideInterval;
            var default_postal_code_radius =  { code: 20, name: '20', selected: true, visible: true };
            let multipleApplyModal;

            $scope.locationstoggled = false;
            $scope.slide = (value) => {
                clearTimeout(slideInterval);

                slideIndex += value;
                const slides = $(".carousel-slides");

                if (slides.length) {
                    slideInterval = setTimeout(() => $scope.slide(1), 4000);
                    slideIndex = (slideIndex < 0) ? slides.length - 1 : (slideIndex === slides.length) ? 0 : slideIndex;

                    slides.css('display', 'none');
                    slides.eq(slideIndex).css('display', 'block');
                }
            };

            $scope.slideSimpleView = (value) => {
                clearTimeout(simpleViewSlideInterval);

                simpleViewSlideIndex += value;
                const slides = $(".simple-view-carousel-slides");

                if (slides.length) {
                    simpleViewSlideInterval = setTimeout(() => $scope.slideSimpleView(1), 4000);
                    simpleViewSlideIndex = (simpleViewSlideIndex < 0) ? slides.length - 1 : (simpleViewSlideIndex === slides.length) ? 0 : simpleViewSlideIndex;

                    slides.css('display', 'none');
                    slides.eq(simpleViewSlideIndex).css('display', 'block');
                }
            };

            $scope.slideSimpleView(0);
            $scope.slide(0);

            $state.$current.reloadOnSearch = false;
            /* Filter Bar */
            $scope.categories = [];
            $scope.positions = [];

            $scope.filter = {
                useLocation: false,
                selectedBrands: [],
                selectedPositions: [],
                selectedJobType: [],
                postal_code_radius:  { code: 20, name: '20', selected: true, visible: true },
                category: {
                    code: 'ALL_CATEGORIES'
                }
            };
            $scope.FULLY_REMOTE_JOB = 'FULLY_REMOTE';
            $scope.showJobTypeFilterToolTip = false;
            $scope.jobTypesList =  [
                {
                    code: 'FULL_TIME',
                    name: $filter("translate")('Full Time'),
                    order: 1
                },
                {
                    code: 'PART_TIME',
                    name: $filter("translate")('Part Time'),
                    order: 2
                },
                {
                    code: 'FULLY_REMOTE',
                    name: $filter("translate")('Fully Remote'),
                    order: 3
                },
                {
                    code: 'HYBRID_REMOTE',
                    name: $filter("translate")('Hybrid Remote'),
                    order: 4
                },
            ];

            $scope.withinDistanceOptions = [
                { code: 3, name: '3' },
                { code: 5, name: '5' },
                { code: 10, name: '10' },
                { code: 20, name: '20' },
                { code: 30, name: '30' },
                { code: 50, name: '50' },
                { code: 100, name: '100' },
            ];

            $scope.currentBrandId = '';
            const isForcePrivatePortal = () => {
                const forcePrivatePortalIds = [4246740, 4241280, 4239538];
                return forcePrivatePortalIds.includes(window.stateParams['id']);
            };

            var isChildBrand = false;
            var $careerPortalNavbar = $(".career-portal-navbar");
            var $careerPortalCoverWrapper = $(".cover-image-wrapper");
            var $jobCard = $(".jobs-board-container .jobs-list");
            var $jobsFilters = $(".jobs-filters");
            var $jobsLocations = $(".jobs-locations-mobile");
            var $careerPortalNavbarToggleNavMenu = $('.career-portal-navbar .toggle-nav-menu');
            var $navBar = $(".nav-bar");
            var $loader = $("#loader");
            var $jobsBoardBody = $('.jobs-board-body');
            var $locationFilterMsg = $('.location-filter-msg');
            var $navbarHeaderSelectBtn = $('.career-portal-navbar .header-select-btn');
            var $navbarHeaderName = $('#navbar-header-name');
            var $activeJobsCount = $('.active-jobs-count');
            var isPrivatePortal = isForcePrivatePortal() || (window.stateParams.isPrivateCareerPortalEnabled && $state.current.isPrivateLink);
            var prev = null, next = null;

            const isMobileOrSmallScreen = () => {
                return deviceChecker.isMobile() || deviceChecker.isTinyScreen();
            };

            hUser.isFromUK()
                .then(function (isFromUK) {
                    $scope.isFromUK = isFromUK;
                    initStoragePolicyBanner({
                        countryCode: isFromUK ? 'UK' : 'US'
                    });
                });

            $scope.brand = CareerPortalDataBus.getBasicInfo();

            if ($scope.brand.settings.candidate_current_location_distance) {
                default_postal_code_radius = {
                    'code': $scope.brand.settings.candidate_current_location_distance,
                    'name': $scope.brand.settings.candidate_current_location_distance.toString(),
                    'selected': true,
                    'visible': true
                };
            }
            $scope.filter.postal_code_radius = default_postal_code_radius;

            var isCarriChatBotEnabled;
            chatBotService.isCarriChatBotEnabled($scope.brand.id)
                .then(function (isEnabled) {
                    isCarriChatBotEnabled = isEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });


            chatBotService.getBrandSettings($scope.brand.id, {channels: ['WEB']})
                .then(function (setting) {
                    $scope.isCarriWebJobPostOnlyEnabled = setting['carri_web_job_post_only_enabled'];
                })
                .catch(function (err) {
                    console.error(err);
                });

            $scope.brandHasTenantJobsService = $scope.brand.public_services && $scope.brand.public_services.indexOf('TENANT_JOBS') > -1;

            //Get the categories & positions
            const getBrandActiveCategoryPositions = () => {
                return new Promise((resolve, reject) => {
                    CareerPortalAPI.getBrandPositions(CareerPortalDataBus.getBrandLevelId())
                        .then((res) => {
                            res = { ...res };
                            $scope.categories = res.position_categories;
                            $scope.positions = [];
                            $scope.filter.category = [];

                            $scope.allPositions = [];
                            for (const i in $scope.categories) {
                                const positions = $scope.categories[i]['position_objects'];
                                $scope.allPositions = [...$scope.allPositions, ...positions];
                            }
                            $scope.positions = $scope.allPositions;
                            updateAppActionButton();
                            syncScope();
                            resolve(res.position_categories);
                        })
                        .catch(() => {
                            reject("NO CATEGORIES");
                        });
                });
            };

            //jobs search conf
            const JOBS_SEARCH_DELAY = 700;
            const JOBS_SEARCH_LOCATION_RADIUS = 20;
            var jobsSearchTimeout = null;
            var appliedJobList = [];
            var draftedJobList = [];
            var requestedBrands = [];

            window.stateParams = window.stateParams || {};

            if ($stateParams.id && $stateParams.slug) {
                window.stateParams.id = $stateParams.id;
                window.stateParams.slug = $stateParams.slug;
            }

            var enterpriseDetails = window.stateParams;
            const CAREER_PORTAL_VIEWS = {
                JOBS_VIEW: 'JOBS_VIEW',
                BRANDS_VIEW: 'BRANDS_VIEW'
            };

            var direction = localize.isRTL() ? 'rtl' : 'ltr';
            $scope.sliderOptions = {
                start: JOBS_SEARCH_LOCATION_RADIUS,
                step: 2,
                direction: direction,
                range: {
                    'min': 0,
                    'max': 50
                },
                stepped: true,
                pips: {
                    mode: 'values',
                    values: [0, 50],
                    density: 15
                }
            };

            // methods implemented using fullscreen-map directive.
            $scope.mapEvents = {};
            $scope.sliderEventHandlers = {
                update: (values, handle, unencoded) => {
                    if (isInteractiveMapEnabled()) {
                        googleMaps.map.setZoom(15 - ((values[0] / 50) * 7.7));
                    } else {
                        $scope.mapEvents.setZoomLevel(15 - ((values[0] / 50) * 7.7));
                    }
                    if ($scope.filter.useLocation) {
                        $scope.doDelayedSearch();
                    }
                }
            };

            $scope.selectBrand = () => {
                $scope.filterJobs();
                $scope.getLocationsForMap();
            };

            $scope.onChangeCategories = () => {
                const selectedCategories = $scope.filter.selectedCategories;
                let selectedCategoryPositions = [];

                if (selectedCategories && selectedCategories.length) {
                    selectedCategories.forEach(category => {
                        selectedCategoryPositions = selectedCategoryPositions.concat(category.position_objects);
                    });
                    $scope.positions = selectedCategoryPositions;
                } else {
                    $scope.positions = $scope.allPositions;
                }

                const positionCodes = $scope.positions.map(position => position.code);
                $scope.filter.selectedPositions = $scope.filter.selectedPositions.filter(position => positionCodes.includes(position.code));

                $scope.doDelayedSearch();
            };

            $scope.selectPosition = () => {
                $scope.filterJobs('FILTER_POSITION');
                $scope.getLocationsForMap('FILTER_POSITION');
            };

            $scope.viewAllBrandJobs = () => {
                $scope.filter.useLocation = false;
                $scope.filterJobs();
                $scope.getLocationsForMap();
            };

            $scope.canMaximizeSearchInput = () => {
                const brandSettings = $scope.brand.settings;

                return !((brandSettings.is_navigation_tree_enabled || brandSettings.locations_filter_mode === 'NAVIGATION_TREE') &&
                    brandSettings.is_postal_code_enabled &&
                    (brandSettings.is_categories_enabled && brandSettings.is_brand_filter_enabled));
            };
            const getUserLocation = async () => {
                let data;
                let source = "network";
                try {
                    const deferred = $q.defer();

                    if (isMobileOrSmallScreen()) {
                        data = await hUser.getUserDeviceLocation();
                        source = "device";
                        setSearchLocation(data, source);
                    } else {
                        data = await hUser.getUserLocation();
                    }
                    $scope.filter.useLocation = true;
                    setSearchLocation(data, source);
                    deferred.resolve();
                    return deferred.promise;
                } catch (error) {
                    $scope.filter.useLocation = false;
                    return Promise.reject(error);
                }
            };
            //User Location for job search
            var setSearchLocation = (data, locationSource) => {
                const newLocation = data;

                if (newLocation.latitude && newLocation.longitude) {
                    const locationObj = $scope.filter.userLocation;

                    if (!locationObj || locationObj.source === 'network') {
                        newLocation.source = locationSource;
                        $scope.filter.userLocation = newLocation;
                    }
                }
            };

            $scope.getBrandsBySearchQuery = function ($event){
                var defer = $q.defer();
                $event.on('start');

                let search_term = $event.value;
                let brand_type= CareerPortalDataBus.getBasicInfo().settings.is_brand_filter_enabled ? CareerPortalDataBus.getBasicInfo().settings.brand_filter_allowed_brand_type : ''
                var brandId = CareerPortalDataBus.getBasicInfo().id

                BrandAPI.getFlattedBrandsTree(brandId, brand_type, 0, 400, 'CAREER_PORTAL', search_term)
                    .then(function (brandsList) {
                        var items = brandsList.brands

                        items.forEach(brand => {
                            brand.external_business_name = brand.external_business_name || brand.name;
                        });

                        defer.resolve(items);
                    }).catch(function (error) {
                    console.error(error);
                }).finally(function () {
                    $event.on('end');
                });
                return defer.promise;
            };

            const setCareerPortalFilters = async (parametersFilters) => {
                let filters = decodeURIComponent(parametersFilters);
                let filterObj = {};
                let availabilty;

                if (filters && filters.length > 0) {
                    filters = filters.split('&');
                    filterObj = filters.reduce((obj, filter) => {
                        const [key, value] = filter.split('=');
                        obj[key] = value;
                        return obj;
                    }, {});
                    availabilty = filterObj.jobsAvailability?.split(',');
                }

                if (filterObj.jobsCategory) {
                    $scope.filter.category = { name: filterObj.jobsCategory };
                }

                if (filterObj['brands'] || CareerPortalDataBus.getBasicInfo().settings.is_brand_filter_enabled) {
                    let selectedBrands = [];
                    if (filterObj['brands']) {
                        selectedBrands = decodeURIComponent(filterObj['brands']).split(',');
                        $scope.filter.selectedBrands = [];
                        for (let i = 0; i < selectedBrands.length; i++) {
                            if (selectedBrands[i]) {
                                $scope.filter.selectedBrands.push({id: parseInt(selectedBrands[i])});
                            }
                        }
                    }
                    $scope.filter.brandFilterObject = filterObj['brands'];
                }

                try {
                    $scope.categories = await getBrandActiveCategoryPositions();
                    const ensureArray = value => Array.isArray(value) ? value : [value];

                    ensureArray(filterObj.jobsCategory).forEach(categoryItem => {
                        if (categoryItem) {
                            $scope.filter.selectedCategories = $scope.categories.filter(category =>
                                categoryItem.includes(encodeURIComponent(category.name))
                            );
                        }
                    });

                    ensureArray(filterObj.jobsPositions).forEach(positionItem => {
                        if (positionItem) {
                            $scope.filter.selectedPositions = $scope.positions.filter(pos =>
                                positionItem.includes(encodeURIComponent(pos.name))
                            );
                        }
                    });

                    if (filterObj.jobsUseLocation === "true" || (CareerPortalDataBus.getBasicInfo().settings.interactive_map_enabled && CareerPortalDataBus.getBasicInfo().settings.map_default_location === 'CANDIDATE_CURRENT_LOCATION')) {
                        await getUserLocation()
                    }

                } catch (error) {
                    console.error(error);
                }

                if (filterObj.jobsPhrase) {
                    $scope.filter.search_phrase = decodeURIComponent(filterObj.jobsPhrase);
                }

                if (filterObj.jobsUseLocation == "true") {
                    $scope.filter.useLocation = filterObj.jobsUseLocation;
                }

                if (filterObj.postalCode) {
                    $scope.filter.postal_code = decodeURIComponent(filterObj.postalCode);

                    if (filterObj.postalCodeRadius) {
                        $scope.filter.postal_code_radius = {
                            'code': filterObj.postalCodeRadius,
                            'name': filterObj.postalCodeRadius.toString(),
                            'selected': true,
                            'visible': true
                        };
                    }
                }

                if (availabilty?.length) {
                    const jobTypeMapping = {
                        fullTime: $scope.jobTypesList[0],
                        partTime: $scope.jobTypesList[1],
                        fullyRemote: $scope.jobTypesList[2],
                        hybridRemote: $scope.jobTypesList[3],
                    };

                    $scope.filter.selectedJobTypes = availabilty.filter(type => jobTypeMapping[type]).map(type => jobTypeMapping[type]);
                }
                $scope.doDelayedSearch(null, null, null, true);
                syncScope();
            };

            if ($stateParams.filters || $location.search().filters) {
                window.careerPortalFilters = $location.search().filters || $stateParams.filters;
                window.careerPortalID = CareerPortalDataBus.getBasicInfo().id;
            }

            if (window.careerPortalID != enterpriseDetails.id) {
                window.careerPortalFilters = null;
                window.careerPortalID = null;
            }

            $scope.activeView = window.careerPortalFilters ? CAREER_PORTAL_VIEWS.JOBS_VIEW : CAREER_PORTAL_VIEWS.BRANDS_VIEW;

            //loading new results
            $scope.loadingValid = true;
            $scope.loading = false;
            $scope.noResults = false;
            $scope.loader = {
                jobs: {
                    offset: 0,
                    limit: 27
                },
                enterpriseBrands: {
                    offset: 0,
                    limit: 99
                }
            };

            //Counter
            $scope.jobsCount = {
                visible: false
            };

            $scope.toggleFilters = () => {
                $scope.showMobileFiltersPanel = true;
            }

            $scope.closeMobileFilters = () => {
                $scope.showMobileFiltersPanel = false;
            }

            $scope.closeLocationsFilters = () => {
                $scope.locationstoggled = false;
                $jobsFilters.removeClass("visible");
                $jobsLocations.removeClass("visible");
                $(".filters-btn.close-btn").removeClass("visible");
                $(".filters-title").removeClass("visible");
                $(".locations-title").removeClass("visible");
                $(".top-bar").removeClass("visible");
                $("body").removeClass("modal-open");
            }

            $scope.toggleLocations = () => {
                $scope.locationstoggled = true;
                $jobsLocations.toggleClass("visible");
                $(".filters-btn.close-btn").toggleClass("visible");//yes
                $(".locations-title").toggleClass("visible");//yes
                $(".top-bar").toggleClass("visible");//yes

                if ($jobsLocations.hasClass("visible")) {
                    $("body").addClass("modal-open");
                } else {
                    $("body").removeClass("modal-open");
                }

                $scope.applyFilters();
            };

            $scope.unfocusSearchField = () => {
                $("#search-query").blur();
                $("#search-cover-query").blur();
            };

            var latestRequest = "";
            var filterJobsTimeout;

            $scope.doDelayedSearch = function (keyChanged, withDelay, isAppending, onInit)  {
                clearTimeout(filterJobsTimeout);

                filterJobsTimeout = setTimeout(() => {
                    $scope.filterJobs(keyChanged, withDelay, isAppending, null, null, null, onInit);
                    if (!isMobileOrSmallScreen() || $scope.showMapOnMobile) {
                        if (!$scope.mapLoaded) {
                            initMap(null, null, onInit)
                        } else {
                            $scope.getLocationsForMap(keyChanged, null, null, null, onInit);
                        }
                    }
                }, 500);

            };

            $scope.searchJobs =  (searchParams, isAppending, isFiltered) => {
                renderLoader(isAppending);
                CareerPortalAPI.searchJobsForBrand(searchParams)
                    .then((jobs) => {
                        if (jobs.requestSignutre !== latestRequest) {
                            return;
                        }

                        const {data} = jobs;
                        $scope.jobSearchResult = data;
                        $scope.jobsResult = data.hits;
                        $scope.showClearBtn = isClearBtnShown();

                        if (!isAppending || data.results.length) {
                            for (const [index, job] of Object.entries(data.results)) {
                                const jobReferer = {
                                    url: `${window.location.pathname}${window.location.search}`,
                                    group: {
                                        id: CareerPortalDataBus.getBasicInfo().id,
                                        name: CareerPortalDataBus.getBasicInfo().name
                                    }
                                };

                                job.redirection_param = encodeURIComponent(JSON.stringify(jobReferer).replace(/'/g, "&apos;"));
                                if (talentScoutCodeId) {
                                    job.talent_scout_code_id = talentScoutCodeId;
                                }
                                if (utmSource) {
                                    job.utm_source = utmSource;
                                }
                                HStorageManager.put({
                                    storageLevel: HStorageManager.StorageLevels.SESSION,
                                    key: 'career_portal_redirection{{job}}',
                                    variables: {
                                        job: job.id
                                    },
                                    value: jobReferer
                                });
                            }

                            const tempBasicInfo = CareerPortalDataBus.getBasicInfo();
                            const tempIsPrivateLink = $state.current.isPrivateLink;

                            if ($state.current.name.includes("internal") && tempIsPrivateLink && tempBasicInfo.isPrivateCareerPortalEnabled) {
                                $scope.isInternalCareerPortal = true;
                            }

                            const numberOfJobs = data.hits;
                            if (numberOfJobs > 0) {
                                let content = $scope.basicInfo.settings.is_number_of_positions_enabled ? `${numberOfJobs} ` : '';
                                content += $filter("translate")('Open Positions');

                                $('.jobs-board-header #numberOfJobsDisplay').html(content);
                            }

                            renderTemplate(data, isAppending, isFiltered);


                            if (numberOfJobs > 0) {
                                $('.empty-job-board').hide()
                            } else {
                                $('.empty-job-board').show();
                            }

                            updateAppActionButton();
                            $('.card-loader').remove();
                            $('.job-list-container').show();

                        }

                        hits = data.hits;
                        syncScope();
                    }).catch((err) => {
                    console.error(err);
                }).finally(() => {
                    $loader.hide();
                    $scope.isLoading = false;
                    requestLock = false;
                    $('.card-loader').remove();
                    $('.job-list-container').show();
                    syncScope();
                });
            };

            function renderLoader(isAppending) {
                const template = DispatcherServices.getNunjucks()
                    .render("modules/profiles/views/gp-career-portal-partials/job-card-loader.tmpl.html", {
                        numberOfCards: $scope.numberOfCards,
                    });
                if (!isAppending) {
                    $("#jobs-list").html(template);
                } else {
                    $(".job-list-container").append(template);
                }

                $('.card-loader').show();
            }

            function renderTemplate(data, isAppending, isFiltered) {
                const { results } = data;
                const tempIsPrivateLink = $state.current.isPrivateLink;

                const template = DispatcherServices.getNunjucks()
                    .render("modules/profiles/views/gp-career-portal-partials/job-list.tmpl.html", {
                        jobSearchResult: data,
                        basicInfo: $scope.basicInfo,
                        isFiltered: isFiltered,
                        isPrivateLink: tempIsPrivateLink,
                        isBrandHasTenantJobsService: $scope.brandHasTenantJobsService,
                        numberOfJobs: data.hits,
                        showClearFilters: !$scope.showFiltersSidebar,
                        isAppending: isAppending,
                        numberOfCards: $scope.numberOfCards,
                        showClearBtn: $scope.showClearBtn
                    });

                $timeout(() => {
                    for (const job of results) {
                        const tempIndex = jobApplyButtonsElms.push($element.find(`.job-apply-button-${job.id}`));
                        jobApplyButtonsElms[tempIndex - 1].off("click").on("click", onApplyClicked);
                    }
                });

                let applying = false;
                function onApplyClicked(event) {
                    if (applying) {
                        return;
                    }
                    applying = true;
                    const tempJob = $(event.target);
                    const jobId = tempJob.data("job-id");
                    const brandId = tempJob.data("brand-id");
                    const jobProfileLink = document.querySelector(`.job-description-${jobId}`);
                    const redirectToJobApply = () => {
                        $timeout(() => {
                            if ($scope.mode === "CARRI_ONLY" && $scope.isCarriWebJobPostOnlyEnabled) {
                                tempJob[0].href = jobProfileLink.href;
                            }
                            tempJob[0].click();
                            applying = false;
                        });
                    };
                    const triggerCarriChatBot = () => {
                        applying = false;
                        const payload = { job_id: jobId };
                        chatBotService.triggerCarriJobApply('apply_for_specific_job', payload);
                    };
                    const handleApplyByMode = async () => {
                        try {
                            const jobDetails = await JobDetailsBus.getJob(jobId);
                            $scope.mode = await chatBotService.getJobApplyMode(brandId, jobDetails.job.Position.code);
                            if ($scope.mode === "CARRI_ONLY" && !$scope.isCarriWebJobPostOnlyEnabled) {
                                triggerCarriChatBot();
                            } else {
                                redirectToJobApply();
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    };

                    if (isCarriChatBotEnabled) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        handleApplyByMode();
                    } else {
                        applying = false;
                    }
                }

                if (!isAppending) {
                    $("#jobs-list").html(template);
                    loadedJobs = results.length;
                    $scope.allJobsSearchResult = results;
                    $scope.showComparisonPanel && !$scope.showComparisonResultPanel && $scope.openComparisonPanel();
                } else {
                    $(".job-list-container").append(template);

                    if ($scope.showComparisonPanel) {
                        hideJobActionButtons();
                        showCompareSelectBtns()
                        $('.card-details').addClass('compare-mode');
                        updateSelectBtnsStatus();
                    }

                    loadedJobs += results.length;
                    $scope.allJobsSearchResult = $scope.allJobsSearchResult.concat(results);
                }

                updateCompensationTooltip('.job-list-container','.compensation-details');
                if ($scope.showComparisonPanel) {
                    updateCompensationTooltip('.job-list-container','.compensation-mobile-details');
                    updateCompensationTooltip('.compare-container', '.compare-compensation-details' );
                }

                $scope.isLoading = false;
            }

            const checkJobTypeFilterToolTip = () => {
                return !!$scope.filter.selectedJobTypes.find((jobType) => jobType.code === $scope.FULLY_REMOTE_JOB);
            };

            const normalizeLatLong = (location) => {
                let lat = location[0];
                let lng = location[1];

                // Normalize longitude to [-180, 180] range
                while (lng > 180) {
                    lng -= 360;
                }
                while (lng < -180) {
                    lng += 360;
                }

                return [lat, lng];
            }

            $scope.filterJobs = (keyChanged, withDelay, isAppending, isEnterpriseChild, center, radius, onInit) => {
                if ($scope.activeView != CAREER_PORTAL_VIEWS.JOBS_VIEW) {
                    $scope.loadingValid = true;
                    $scope.activeView = CAREER_PORTAL_VIEWS.JOBS_VIEW;
                }

                var preparedData = prepareSearchParams(keyChanged, isEnterpriseChild, isAppending, false, center, radius, onInit);
                var searchParams = preparedData.searchParams;
                var isFiltered = preparedData.isFiltered;
                searchParams['flow'] = 'CAREER_PORTAL';
                $scope.checkFiltersSelected();
                $scope.showJobTypeFilterToolTip = checkJobTypeFilterToolTip();

                if (!requestLock) {
                    latestRequest = JSON.stringify(searchParams);
                    requestLock = true;
                    $loader.show();
                    $scope.isLoading = true;
                    $('.card-loader').show();

                    if (searchParams.locations) {
                        if (validateLocation(searchParams.locations[0], searchParams.locations[1])) {
                            $scope.searchJobs(searchParams, isAppending, isFiltered);
                        } else {
                            $scope.isLoading = false;
                            requestLock = false;
                        }
                    } else {
                        $scope.searchJobs(searchParams, isAppending, isFiltered);
                    }
                }
                //put timeout for search
                updateURL();
            };

            const prepareSearchParams = (keyChanged, isEnterpriseChild, isAppending, isMapSearch, center, radius, onInit) => {
                $scope.appliedFiltersCount = 0;

                let searchParams = {};
                if (keyChanged === 'FILTER_CATEGORY') {
                    $scope.filter.category = $scope.categories.find(category => category.code === $scope.filter.category_code);
                    $scope.filter.selectedPositions = [];
                }
                if (!isMapSearch) {
                    searchParams = {
                        size: 30,
                        source: 'web'
                    };
                }

                const brandLevelId = CareerPortalDataBus.getBrandLevelId() || $scope.parentOfChildId;
                if (brandLevelId) {
                    searchParams.brand_level_ids = [brandLevelId];
                }

                if (isEnterpriseChild && $scope.brand.settings.locations_filter_mode !== 'MULTIPLE_LOCATIONS') {
                    searchParams.explicit_brand_ids = [brandLevelId];
                }

                if ($scope.filter.selectedBrands.length) {
                    searchParams.brand_level_ids = $scope.filter.selectedBrands.map(brand => brand.id);
                    $scope.appliedFiltersCount++;
                }

                let isFiltered = false;
                if ($scope.filter.search_phrase && $scope.filter.search_phrase.length) {
                    searchParams.search_phrase = $scope.filter.search_phrase;
                    isFiltered = true;
                    $scope.appliedFiltersCount++;
                }

                if ($scope.filter.useLocation) {
                    const userLocation = $scope.filter.userLocation;
                    if (userLocation && (userLocation.latitude || userLocation.lat || userLocation.longitude || userLocation.lon)) {
                        const latitude = userLocation.latitude || userLocation.lat || center.lat;
                        const longitude = userLocation.longitude || userLocation.lon || center.lng;

                        if (!isNaN(latitude) && !isNaN(longitude)) {
                            searchParams.radius = $scope.sliderOptions.start || radius;
                            searchParams.locations = [parseFloat(latitude), parseFloat(longitude)];
                            searchParams.sort = ['distance'];
                            isFiltered = true;
                        } else {
                            console.error('Trying to search useLocation:', $scope.filter.useLocation, 'User Location:', userLocation);
                        }
                        $scope.appliedFiltersCount++;
                    }
                }

                if (onInit && isInteractiveMapEnabled() && $scope.brand.settings.map_default_location === 'CANDIDATE_CURRENT_LOCATION' &&  $scope.filter.userLocation) {
                    const userLocation = $scope.filter.userLocation;
                    searchParams.radius = $scope.brand.settings.candidate_current_location_distance;
                    searchParams.locations = [userLocation.lat || userLocation.latitude, userLocation.lon || userLocation.longitude];
                    searchParams.sort = ['distance'];
                    isFiltered = true;
                } else if (isInteractiveMapEnabled() && radius && center) {
                    searchParams.radius = radius;
                    searchParams.locations = [parseFloat(center.lat), parseFloat(center.lng)];
                    searchParams.sort = ['distance'];
                    isFiltered = true;
                }

                if ($scope.filter.selectedPositions && $scope.filter.selectedPositions.length) {
                    searchParams.positions = $scope.filter.selectedPositions.map(pos => pos.name);
                    isFiltered = true;
                    $scope.appliedFiltersCount++;
                }

                if ($scope.filter.postal_code) {
                    searchParams.postal_code = $scope.filter.postal_code;
                    isFiltered = true;
                    $scope.appliedFiltersCount++;


                    if ($scope.filter.postal_code_radius) {
                        searchParams.postal_code_radius = $scope.filter.postal_code_radius.code;
                        isFiltered = true;
                        $scope.appliedFiltersCount++;
                    }
                }

                if ($scope.filter.selectedCategories && $scope.filter.selectedCategories.length) {
                    searchParams.categories = $scope.filter.selectedCategories.map(category => category.name);
                    isFiltered = true;
                    $scope.appliedFiltersCount++;
                }

                if ($scope.filter.selectedJobTypes?.length) {
                    searchParams['availability'] = [];

                    const jobTypeMap = {
                        'FULL_TIME': 'full_time',
                        'PART_TIME': 'part_time',
                        'FULLY_REMOTE': 'fully_remote',
                        'HYBRID_REMOTE': 'hybrid_remote'
                    };

                    $scope.filter.selectedJobTypes.forEach((jobType) => {
                        const availabilityValue = jobTypeMap[jobType.code];

                        if (availabilityValue) {
                            searchParams['availability'].push(availabilityValue);
                            isFiltered = true;
                        }
                    });

                    $scope.appliedFiltersCount++;
                }

                if (isAppending) {
                    searchParams.start = loadedJobs;
                }

                if (!requestLock || !mapRequestLock) {
                    if ($state.current.isPrivateLink || isForcePrivatePortal()) {
                        searchParams.job_search_type = 'PRIVATE';
                    }

                    if (!searchParams.sort || searchParams.sort.length === 0) {
                        searchParams.sort = ['publish_date'];
                        searchParams.sort_type = 'desc';
                    }
                }

                return { searchParams, isFiltered };
            };

            const validateLocation = (lat, lon) => {
                // Validate latitude ranges from -90 to 90 and longitude ranges from -180 to 180
                return lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
            };

            //hard refresh to solve loop issue
            $('.h-career-portal').on('click', '.brand-view-btn', (e) => {
                // e.preventDefault();
                hRedirect(hGetCurrentUrl() + '?brand_view=true');
            });

            //Sync Scope
            const syncScope = () => {
                setTimeout(() => {
                    $scope.$digest();
                }, 1);
            };

            const scrollThresold = 240;
            let totalHeight = $("body").height() - $jobsBoardBody.offset().top + scrollThresold;

            $(window).on('resize', (e) => {
                if (isMobileOrSmallScreen()) {
                    $('.career-portal-navbar .select-btn').css('display', 'block');
                } else {
                    $('.career-portal-navbar .select-btn').css('display', 'none');
                }

                $careerPortalNavbarToggleNavMenu.css('display', 'none');
                totalHeight = $("body").height() - $jobsBoardBody.offset().top + scrollThresold;

                restHeaderStyle();
                loadMoreJobs()
            });

            $('#jobs-list').on('scroll', (e) => {
                loadMoreJobs()

                if ($(window).width() <= 575) {
                    if ($('#jobs-list').scrollTop() > 0) {
                        $('.cover-image-wrapper').css('height', '4.5rem');
                        $('.user-avatar').css('display', 'none');
                        $('.end-items').css('margin-top', '-25px');

                    } else {
                        restHeaderStyle();
                    }
                }

            });

            const restHeaderStyle = () => {
                $('.cover-image-wrapper').css('height', '11rem');
                $('.user-avatar').css('display', 'block');
                $('.end-items').css('margin-top', '0');
            }

            const loadMoreJobs = () => {
                if (!requestLock && hits > loadedJobs && (totalHeight + $(document).scrollTop() > $jobsBoardBody.height())) {
                    $scope.filterJobs('', false, true);
                }
            };

            //handle scope destroy
            const destroyEventHandlers = () => {
                $(window).off("scroll");
                $(window).off("resize");

                multipleApplyModal?.hide();

                $jobsFilters.off('focus', "#search-query");
                $jobsFilters.off('blur', "#search-query");

                $jobsLocations.off('focus', "#search-query");
                $jobsLocations.off('blur', "#search-query");

                for (const $jobApplyButtonElm of jobApplyButtonsElms) {
                    $jobApplyButtonElm.off("click");
                }

                $careerPortalNavbar.off('click');
                $("#jobs-list").off('click');
                $('.h-career-portal').off('click');

                JobDetailsBus.onJobApplyFinish = () => {};
                JobDetailsBus.onJobApplyUpdate = () => {};

                window.removeEventListener('popstate', browserBackButtonListener);

                googleTagManagerTrackingService.destroy();

                // Unregister tracking
                if (typeof HThirdPartyManager !== 'undefined') {
                    HThirdPartyManager.unregister(HStoragePolicyManager.Categories.ANALYTICS, 'career_portal_tracking');
                }
            };

            $scope.$on("$destroy", destroyEventHandlers);

            //get current User applided Jobs
            const getUserAppliedJobs = () => {
                var deferred = $q.defer();
                var brandIds = [];
                var jobs = CareerPortalDataBus.getJobs().results;

                for (var jobIndex in jobs) {
                    var job = jobs[jobIndex];
                    if (appliedJobList.indexOf(job.id) == -1 && draftedJobList.indexOf(job.id) == -1) {
                        if (requestedBrands.indexOf(job.brand.id) === -1) {
                            requestedBrands.push(job.brand.id);
                            brandIds.push(job.brand.id);
                        }
                    }
                }

                if (brandIds.length > 0) {
                    UserAPI.getUserAppliedJobs(brandIds).then(function (res) {
                        for (var jobIndex in res) {
                            var job = res[jobIndex];
                            if (job.is_draft && draftedJobList.indexOf(job.job_id) == -1) {
                                draftedJobList.push(job.job_id);
                            } else if (job.applied && appliedJobList.indexOf(job.job_id) == -1) {
                                appliedJobList.push(job.job_id)
                            }
                        }
                        deferred.resolve();
                    }, function (res) {
                        console.error('an error with user applied jobs', res);
                    });
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            };

            //Update Applications action button
            var updateAppActionButton = function (clean) {
                if (hUser.isLoggedIn()) {
                    getUserAppliedJobs().then(function (appliedJobs) {
                        for (var i in appliedJobList) {
                            var data = {
                                job: {
                                    id: appliedJobList[i],
                                    applied: true
                                },
                                basicInfo: CareerPortalDataBus.getBasicInfo()
                            };

                            var template = DispatcherServices.getNunjucks()
                                .render("modules/profiles/views/career-portal-partials/app-action-btn.tmpl.html", data);
                            $('.action-btn-holder-' + appliedJobList[i]).html(template);
                        }
                        for (var i in draftedJobList) {
                            var data = {
                                job: {
                                    id: draftedJobList[i],
                                    is_draft: true
                                },
                                basicInfo: CareerPortalDataBus.getBasicInfo()
                            };

                            var template = DispatcherServices.getNunjucks()
                                .render("modules/profiles/views/career-portal-partials/app-action-btn.tmpl.html", data);
                            $('.action-btn-holder-' + draftedJobList[i]).html(template);
                        }
                    });
                }
            };

            //listen for any job that is applied through career portal and update buttons upon
            JobDetailsBus.onJobApplyFinish = async (status, appId, applyDate, jobId) => {
                try {
                    const jobDetails = await JobDetailsBus.getJob(jobId);
                    if ([JobDetailsBus.SUCCESS, JobDetailsBus.WOTC_SUCCESS, JobDetailsBus.WOTC_NOT_COMPLETED, JobDetailsBus.SUCCESS_NO_PASSWORD].includes(status)) {
                        if (status === JobDetailsBus.SUCCESS || status === JobDetailsBus.SUCCESS_NO_PASSWORD) {
                            if (jobDetails.brand.public_services && jobDetails.brand.public_services.includes("WOTC")) {
                                const res = await WOTCAPI.getBrandWotcSettings(jobDetails.brand.id);
                                if (res['workflow_mode'] === 'IN_APPLICATION') {
                                    $state.go('.wotc', {
                                        brand_id: jobDetails.brand.id,
                                        job_id: jobId,
                                        app_id: appId
                                    });
                                } else {
                                    await handleOutmatchAssessment(jobDetails, jobDetails.brand.id, status, appId, jobDetails.job.id);
                                }
                            } else {
                                await handleOutmatchAssessment(jobDetails, jobDetails.brand.id, status, appId, jobDetails.job.id);
                            }
                        } else {
                            await handleOutmatchAssessment(jobDetails, jobDetails.brand.id, status, appId, jobDetails.job.id);
                        }
                    }
                } catch (err) {
                    console.error(err);
                    jobApplyFactory.PrepareApplySuccessModal(jobId, status).then((data)=>{
                        $.extend($scope, data)
                        jobApplyFactory.showApplySuccessModal();
                        $scope.$digest();
                    });
                } finally {
                    $scope.$digest();
                }
            };

            const handleOutmatchAssessment = async (jobDetails, brandId, status, appId, jobId) => {
                const nextFlowCallback = () => {
                    jobApplyFactory.PrepareApplySuccessModal(jobId, status).then((data)=>{
                        $.extend($scope, data)
                        jobApplyFactory.showApplySuccessModal();
                        $scope.$digest();
                    });
                };
                await outmatchAssessmentService.processOutmatchAssessment(jobDetails, brandId, status, appId, jobId, nextFlowCallback);
            };

            //listen for any job that is applied through career portal and update buttons upon
            JobDetailsBus.onJobApplyUpdate = (status, appId, applyDate, jobId) => {
                switch (status) {
                    case JobDetailsBus.SUCCESS:
                    case JobDetailsBus.DRAFTED:
                    case JobDetailsBus.APPLIED:
                        if (status === JobDetailsBus.DRAFTED) {
                            if (!draftedJobList.includes(jobId)) {
                                draftedJobList.push(jobId);
                            }
                        } else {
                            if (!appliedJobList.includes(jobId)) {
                                const draftedIndex = draftedJobList.indexOf(jobId);
                                if (draftedIndex !== -1) {
                                    draftedJobList.splice(draftedIndex, 1);
                                }
                                appliedJobList.push(jobId);
                            }
                        }
                        updateAppActionButton();
                        break;
                }
            };

            //Update CareerPortal URL
            const updateURL = (withDelay) => {
                const pathObject = {};

                if ($scope.filter.company) {
                    pathObject['jobsBrand'] = $scope.filter.company;
                }

                if ($scope.filter.selectedCategories && $scope.filter.selectedCategories.length) {
                    pathObject['jobsCategory'] = $scope.filter.selectedCategories.map(category => encodeURIComponent(category.name));
                }

                if ($scope.filter.selectedPositions && $scope.filter.selectedPositions.length) {
                    pathObject['jobsPositions'] = $scope.filter.selectedPositions.map(position => encodeURIComponent(position.name));
                }

                if ($scope.filter.search_phrase) {
                    pathObject['jobsPhrase'] = encodeURIComponent($scope.filter.search_phrase);
                }

                if ($scope.filter.postal_code) {
                    pathObject['postalCode'] = encodeURIComponent($scope.filter.postal_code);

                    if ($scope.filter.postal_code_radius) {
                        pathObject['postalCodeRadius'] = encodeURIComponent($scope.filter.postal_code_radius.code);
                    }
                }

                if ($scope.filter.useLocation) {
                    pathObject['jobsUseLocation'] = "true";
                }

                if ($scope.filter.selectedBrands && $scope.filter.selectedBrands.length) {
                    pathObject['brands'] = encodeURIComponent($scope.filter.selectedBrands.map(brand => brand.id));
                }

                if ($scope.filter.selectedJobTypes?.length) {
                    const jobTypeMap = {
                        'FULL_TIME': 'fullTime',
                        'PART_TIME': 'partTime',
                        'FULLY_REMOTE': 'fullyRemote',
                        'HYBRID_REMOTE': 'hybridRemote'
                    };

                    pathObject['jobsAvailability'] = $scope.filter.selectedJobTypes.map(jobType => jobTypeMap[jobType.code]);
                }

                const parentOfChildId = $location.search().group_id || $scope.parentOfChildId;
                if ((parentOfChildId && isChildBrand) || ($location.search().group_id && isChildBrand)) {
                    pathObject['groupId'] = parentOfChildId;
                }

                const brandId = $scope.currentBrandId || $location.search().brand_id;
                if (brandId) {
                    pathObject['currentBrandId'] = brandId;
                }
                let filtersString = '';
                let currentBrandString = '';
                let groupIdString = '';
                for (let i in pathObject) {
                    if (i === 'groupId') {
                        groupIdString += (groupIdString ? '&' : '') + pathObject[i];
                    } else if (i === 'currentBrandId') {
                        currentBrandString += (currentBrandString ? '&' : '') + pathObject[i];
                    } else {
                        filtersString += (filtersString ? '&' : '') + i + '=' + pathObject[i];
                    }
                }
                // Make sure that there is nothing to block the scroll (due to apply modal being opened before)
                $("body").removeClass("modal-open");

                let delay = withDelay ? JOBS_SEARCH_DELAY : 1;
                $timeout.cancel(jobsSearchTimeout);
                jobsSearchTimeout = $timeout(()=> {
                    $state.go(".", {
                        brand_id: parseInt(currentBrandString) === CareerPortalDataBus.getBasicInfo().id ? null : currentBrandString,
                        group_id: groupIdString,
                        filters: encodeURIComponent(filtersString)
                    });
                    window.careerPortalFilters = encodeURIComponent(filtersString);
                    window.careerPortalID = CareerPortalDataBus.getBasicInfo().id;

                    $scope.$apply();
                }, delay);
                //put timeout for search
            };

            const browserBackButtonListener = (event) => {
                $scope.parentOfChildId = $location.search().group_id || '';
                $scope.currentBrandId = $location.search().brand_id || '';
                window.careerPortalFilters = $location.search().filters;
                window.careerPortalID = enterpriseDetails.id;
                init();
            };

            window.addEventListener('popstate', browserBackButtonListener);

            $scope.trackEnhanceProfileClick = (profileScore) => {
                hEvent.track("enhance_profile_click", {category: 'job_apply', label: profileScore});
            };

            $scope.handleShowMap = () => {
             //   $(".jobs-board-body #jobs-list").fadeOut('slow').fadeIn('slow');
                // Check if the map is visible and add/remove the full-width class accordingly
                let isMapVisible = $(".map_container").is(":visible");
                if (!isMapVisible) {
                    $(".jobs-board-body #jobs-list").removeClass("full-width");
                } else {
                    $(".jobs-board-body #jobs-list").addClass("full-width");
                }

                $(".map_container").fadeToggle("slow", () => {
                    let isMapVisible = $(".map_container").is(":visible");

                    // Update the link text based on the map visibility
                    const linkText = isMapVisible ? $filter("translate")('Hide map') : $filter("translate")('Show map');
                    $(".jobs-board-header .jobs-board-header-map-action").text(linkText);
                });
                $scope.showInteractiveMap();
            }

            const isClearBtnShown = () => {
                const basicInfo = CareerPortalDataBus.getBasicInfo().settings;
                const isCategoriesEnabled = basicInfo.is_categories_enabled;
                const isPositionsEnabled = basicInfo.is_positions_enabled;
                const isBrandFilterEnabled = basicInfo.is_brand_filter_enabled;
                const isJobTypeEnabled = basicInfo.is_job_type_enabled;
                const isTenantJobEnabled = basicInfo.isTenantJobEnabled;
                const isLocationFilterEnabled = basicInfo.is_use_my_location_enabled || (basicInfo.interactive_map_enabled && basicInfo.map_default_location === 'CANDIDATE_CURRENT_LOCATION')
                const hasResults = $scope.jobSearchResult.results.length > 0;

                return (isCategoriesEnabled || isPositionsEnabled || isBrandFilterEnabled || (isJobTypeEnabled && !isTenantJobEnabled)) || hasResults || isLocationFilterEnabled;
            };

            $scope.showAccessibilityTool = () => {
                accessibilityToolsService.showAccessibilityTool()
            }

            const updateBrandTheme = () => {
                let profileImage;
                if (CareerPortalDataBus.getBasicInfo().media) {
                    profileImage = _.findWhere(CareerPortalDataBus.getBasicInfo().media, {'type': 'profile_image'});
                }
                $scope.theme = {
                    scheme_settings: CareerPortalDataBus.getBasicInfo().scheme_settings,
                    profile_image: profileImage || null,
                }
                appLayoutViewService.updateBrandTheme($scope.theme, 'career_portal_theme', $element.find(`.h-gp-career-portal`).context);
            }

            let checkIfShowSettingsEnabled = () => {
                return $scope.basicInfo.isAccessibilityToolServiceEnabled || $scope.basicInfo.settings.other_languages_enabled ||
                    $scope.basicInfo.url || $scope.basicInfo.facebook_url || $scope.basicInfo.twitter_url || $scope.basicInfo.instagram_url || $scope.basicInfo.linkedin_url;
            };

            const handleAccessibilityTool = () => {
                if (!hUser.isEmployer() && CareerPortalDataBus.getBasicInfo().public_services &&
                    CareerPortalDataBus.getBasicInfo().public_services.indexOf("ACCESSIBILITY_TOOL") > -1) {
                    let accessibilityToolSettings = CareerPortalDataBus.getBasicInfo().accessibility_tool_settings;
                    if (accessibilityToolSettings.accessibility_usage_allowed) {
                        $scope.isAccessibilityButtonShown = true;
                        accessibilityToolsService.initAccessibilityTool(accessibilityToolSettings)
                    }
                } else {
                    accessibilityToolsService.hideAccessibilityTool();
                }
            }

            const isMultipleLocationsModeFilterEnabled = () => {
                return $scope.brand.settings.locations_filter_mode === 'MULTIPLE_LOCATIONS';
            }

            const isInteractiveMapEnabled = () => {
                return $scope.brand.settings.interactive_map_enabled;
            }

            //Init career portal
            let init = () => {
                $scope.basicInfo = CareerPortalDataBus.getBasicInfo();
                $scope.searchPlaceholder = $scope.basicInfo.public_services?.indexOf('TENANT_JOBS') > -1
                    ? $filter("translate")('Search for businesses and locations')
                    : $filter("translate")('Search for Jobs, businesses and locations');
                $scope.filter.selectedCategories = [];
                $scope.filter.selectedPositions = [];
                $scope.filter.selectedBrands = [];
                $scope.filter.selectedJobTypes = [];
                $scope.showFiltersSidebar = false;
                $scope.numberOfCards = [];
                $scope.distanceOptions = [3, 5, 10, 20, 30, 50, 100];
                $scope.cardsCount = 8;
                for (let i = 0; i < $scope.cardsCount; i++) {
                    $scope.numberOfCards.push({
                        id: i
                    })
                }

                if ($scope.basicInfo.public_services?.includes('GLOBAL_TALENT_POOL') &&
                    $scope.basicInfo.global_talent_pool_settings?.apply_to_talent_pool) {
                    CoreReaderAPI.getTalentPoolJobs($scope.basicInfo.id)
                        .then(talentPoolJob => {
                            if (Object.keys(talentPoolJob).length === 0) {
                                $('.cover-image-inner .join-talent-pool').removeClass('d-flex').addClass('d-none');
                                $scope.showTalentPool = false;
                            } else {
                                $scope.talentPoolJob = talentPoolJob;
                                $('.cover-image-inner .join-talent-pool').removeClass('d-none').addClass('d-flex');
                                $scope.showTalentPool = true;
                            }
                        });
                }


                $scope.languages = [{
                    id: 'en',
                    name: 'EN'
                }, {
                    id: 'fr',
                    name: 'FR'
                }, {
                    id: 'es',
                    name: 'ES'
                }];
                handleAccessibilityTool();
                updateBrandTheme();

                $scope.isShowSettingsEnabled =  checkIfShowSettingsEnabled();

                $navbarHeaderSelectBtn.css('display', 'none');
                $locationFilterMsg.css('display', 'none');

                if ($scope.theme.scheme_settings) {
                    let bannerColor = ($scope.theme.scheme_settings?.career_portal_banner_color || $scope.theme.scheme_settings?.accent_color || '#0088DD');
                    document.documentElement.style.setProperty('--career_portal_banner', bannerColor);
                } else {
                    document.documentElement.style.setProperty('--career_portal_banner', '#0088DD');
                }

                appLayoutViewService.updateBrandTheme($scope.theme, 'career_portal_theme', $element.find(`.h-gp-career-portal`).context);

                $('.career-portal-navbar .header-select-btn').css('display', 'none');
                $('.location-filter-msg').css('display', 'none');
                $('.closet-max-jobs-msg').css('display', 'none');

                if (isMobileOrSmallScreen()) {
                    $('.map_container').css('display', 'none')
                }

                $scope.parentOfChildId = CareerPortalDataBus.getBasicInfo().id;

                $jobsFilters.on('focus', "#search-query", () => {
                    $(this).attr("placeholder", "");
                    $("#magnifier-search-icon").css("display", "none");
                })

                $jobsFilters.on('blur', "#search-query", () => {
                    $(this).attr("placeholder", ($scope.brandHasTenantJobsService ?
                        $filter("translate")("Search for businesses and locations") :
                        $filter("translate")("Search for Jobs, businesses and locations")));
                    $("#magnifier-search-icon").css("display", "block");
                })

                $jobsLocations.on('focus', "#search-query", () => {
                    $(this).attr("placeholder", "");
                    $("#magnifier-search-icon").css("display", "none");
                });

                $jobsLocations.on('blur', "#search-query", () => {
                    $(this).attr("placeholder", ($scope.brandHasTenantJobsService ?
                        $filter("translate")("Search for businesses and locations") :
                        $filter("translate")("Search for Jobs, businesses and locations")));
                    $("#magnifier-search-icon").css("display", "block");
                })

                $(".profile").on('click', (e) => {
                    let dontClose = $(e.target).closest('.multi-select').find('.multi-select-dropdown').attr('ng-show');

                    let closeArray = [
                        'openPositionsFilter',
                        'openBrandsFilter',
                    ];

                    for (let i in closeArray) {
                        if (closeArray[i] !== dontClose) {
                            $scope[closeArray[i]] = false;
                        }
                    }
                    $scope.$digest();
                });

                $("#jobs-list").on('click', '.clear-filters',  (e)=> {
                    $scope.resetFilters();
                })


                $careerPortalNavbar.on('click', '.nav-bar-header', (e) => {
                    if (!$navBar.hasClass("expanded")) {
                        $navBar.addClass("expanded");
                        if (backTo.length === 0 && !prev && !next) {
                            $navbarHeaderSelectBtn.css('display', 'block');
                        } else {
                            $navbarHeaderSelectBtn.css('display', 'none');
                        }
                        checkNavigatorControls();
                    }

                    if (isMultipleLocationsModeFilterEnabled()) {
                        drawSelectedBrands();
                    }
                })

                $careerPortalNavbar.on('click', '.toggle-nav-menu', (e) => {
                    $navBar.toggleClass("expanded");
                    checkNavigatorControls();
                    if (!$navBar.hasClass("expanded")) {
                        if (selectedCategory && !_.isEmpty(selectedCategory)) {
                            if (selectedCategory.type !== "CHILD") {
                                navigateToTarget(selectedCategory.targetId, selectedCategory.index)
                            } else {
                                $navbarHeaderName.html(selectedCategory.targetName)
                            }
                        }

                        $('.header-select-btn').css('display', 'none');
                        if (enterpriseData.name && enterpriseData.selected_child && enterpriseData.selected_child.name) {
                            $navbarHeaderName.html(enterpriseData.selected_child.name);
                            $activeJobsCount.html(enterpriseData.selected_child.active_jobs_count);
                        }
                    } else {
                        if (backTo.length === 0 && isMobileOrSmallScreen() && !prev && !next) {
                            $navbarHeaderSelectBtn.css('display', 'block');
                        } else {
                            $navbarHeaderSelectBtn.css('display', 'none');
                        }

                        if (selectedCategory.targetName != selectedCategory.targetParent) {
                            $navbarHeaderName.html(selectedCategory.targetParent)
                        }

                        if (enterpriseData.name && enterpriseData.selected_child && enterpriseData.selected_child.name) {
                            $navbarHeaderName.html(enterpriseData.name);
                            $activeJobsCount.html(enterpriseData.active_jobs_count);
                        }
                    }
                });

                $('#search-query').on('focus', () => {
                    $('.h-gp-career-portal .h-filter-box.merged-box').addClass('focus');
                });

                $('#search-query').on('blur', () => {
                    $('.h-gp-career-portal .h-filter-box.merged-box').removeClass('focus');
                });


                var totalSelectedJobs = 0;
                $careerPortalNavbar.on('click', '.nav-element', function (e) {
                    let targetBrandId = e.currentTarget.getAttribute("data-brand-id");
                    let targetBrandName = e.currentTarget.getAttribute("data-brand-name");
                    let type = e.currentTarget.getAttribute("data-brand-type");
                    let activeJobsCount = e.currentTarget.getAttribute("data-active-jobs-count");
                    $locationFilterMsg.css('display', 'block');
                    $(this).addClass("active");

                    parentName = targetBrandName;
                    selectedCategory.targetId && (selectedCategory.targetId = targetBrandId);

                    $(this).hasClass('has-children') && (totalSelectedJobs = 0);

                    if ($(this).hasClass('enterprise')) {
                        isChildBrand = true;
                        $scope.currentBrandId = targetBrandId;
                        updateView(targetBrandId, true, false, true);
                    } else {
                        if (e.currentTarget.getAttribute("data-brand-type") !== "CHILD") {
                            $scope.parentOfChildId = targetBrandId;
                            $scope.currentBrandId = targetBrandId;

                            isChildBrand = false;
                            let index = parseInt(e.currentTarget.getAttribute("data-index")) - 1;
                            $(e.currentTarget).addClass("loading");
                            navigateToTarget(targetBrandId, index);
                        } else {
                            isChildBrand = true;
                            $scope.currentBrandId = targetBrandId;
                            updateView(targetBrandId, true, false, true);
                        }
                    }

                    if ((type === 'CHILD' || $(this).hasClass('enterprise')) && $(this).hasClass("active")) {
                        if ($(this).hasClass("highlighted")) {
                            if (totalSelectedJobs) {
                                totalSelectedJobs -= parseInt(activeJobsCount);
                            }
                        } else {
                            totalSelectedJobs += parseInt(activeJobsCount);
                        }
                        $(".nav-element").removeClass("highlighted");
                        $("#brand-" + $scope.currentBrandId).addClass("highlighted");
                    }

                    $scope.currentBrandId = targetBrandId;
                    if ($scope.currentBrandId) {
                        $locationFilterMsg.css('display', 'block');
                    }
                    let index = parseInt(e.currentTarget.getAttribute("data-index")) - 1;

                    selectedCategory = {
                        targetId: targetBrandId,
                        targetName: targetBrandName,
                        targetParent: parentName,
                        index: index,
                        type: type,
                        activeJobsCount: isChildBrand ? activeJobsCount : totalSelectedJobs
                    };

                    try {
                        const isEnterprise = $(this).hasClass('enterprise');

                        $scope.filterJobs('', false, false, isEnterprise);
                        $scope.getLocationsForMap('', isEnterprise);
                    } catch (error) {
                        console.error(error);
                    }

                    checkNavigatorControls();

                    if (!$navBar.hasClass("expanded")) {
                        if (selectedCategory && !_.isEmpty(selectedCategory)) {
                            if (selectedCategory.type !== "CHILD" && !$(this).hasClass('enterprise')) {
                                navigateToTarget(selectedCategory.targetId, selectedCategory.index);
                            } else {
                                $navbarHeaderName.html(selectedCategory.targetName);
                                $(".brand-details .active-jobs-count").html(selectedCategory.activeJobsCount);
                            }
                        }

                        $('.header-select-btn').css('display', 'none');
                    }

                    CareerPortalDataBus.setBrandLevelId(targetBrandId);

                    if (isMultipleLocationsModeFilterEnabled() && (selectedCategory.type === "CHILD" || $(this).hasClass('enterprise'))) {
                        let targetBrandId = parseInt(e.currentTarget.getAttribute("data-brand-id"));
                        let targetBrandName = e.currentTarget.getAttribute("data-brand-name");
                        let type = e.currentTarget.getAttribute("data-brand-type");

                        let index = $scope.filter.selectedBrands.findIndex((item) => {
                            return item.id === targetBrandId;
                        })

                        if (index != null && index !== -1) {
                            $scope.filter.selectedBrands.splice(index, 1);
                        } else {
                            $scope.filter.selectedBrands.push({
                                id: targetBrandId,
                                type: type,
                                name: targetBrandName
                            });
                        }

                        drawSelectedBrands();
                    }
                });

                const drawSelectedBrands = () => {
                    if ($scope.brand.settings.locations_filter_mode !== 'MULTIPLE_LOCATIONS') {
                        return;
                    }
                    var selectedBrandsIds = _.pluck($scope.filter.selectedBrands, 'id');
                    var selectLabel = $filter('translate')('select');
                    $('.select-btn').removeClass('active');
                    $('.select-btn').text(selectLabel);
                    $('.select-btn').css('border-color', '#0088DDFF');
                    $('.select-btn').css('color', '#0088DDFF');
                    var parent = $('.nav-bar-menu');
                    var navElements = parent.find('.nav-element[data-brand-id]');
                    for (var i = 0; i < navElements.length; i++) {
                        var navElement = $(navElements[i]);
                        navElement.removeClass('highlighted');
                        if (selectedBrandsIds.indexOf(parseInt(navElement.attr('data-brand-id'))) > -1) {
                            navElement.addClass('highlighted');
                            var btn = navElement.find('.select-btn');
                            btn.text($filter("translate")("Selected"));
                            btn.addClass('active');
                        }
                    }
                };

                $careerPortalNavbar.on('click', '.select-btn', async(e) => {
                    e.stopPropagation();
                    $locationFilterMsg.css('display', 'block');

                    if (isMultipleLocationsModeFilterEnabled()) {
                        var parent = $(this).parent();
                        var element = parent[0];
                        let targetBrandId = parseInt(element.getAttribute("data-brand-id"));
                        let targetBrandName = element.getAttribute("data-brand-name");
                        let type = element.getAttribute("data-brand-type");

                        let index = $scope.filter.selectedBrands.findIndex((item) => {
                            return item.id === targetBrandId;
                        });

                        if (index != null && index !== -1) {
                            $scope.filter.selectedBrands.splice(index, 1);
                        } else {
                            $scope.filter.selectedBrands.push({
                                id: targetBrandId,
                                type: type,
                                name: targetBrandName
                            });
                        }
                        drawSelectedBrands();
                        $scope.filterJobs();
                        $scope.getLocationsForMap();
                    } else {

                        $(".select-btn").removeClass("active");
                        $('.nav-element').find('.select-btn').text($filter("translate")("Select"));
                        $('.nav-element').find('.select-btn').css('border-color', '#0088DDFF');
                        $('.nav-element').find('.select-btn').css('color', '#0088DDFF');
                        $(this).addClass("active");
                        $(this).text($filter("translate")("Selected"));

                        var parent = $(this).parent();
                        var element = parent[0];
                        let targetBrandId = element.getAttribute("data-brand-id");
                        let targetBrandName = element.getAttribute("data-brand-name");
                        let type = element.getAttribute("data-brand-type");
                        let activeJobsCount = element.getAttribute("data-active-jobs-count");
                        var isChildEnterprise = parent.hasClass('enterprise');

                        isChildBrand = false;

                        if (type !== "CHILD" && !isChildEnterprise) {
                            $scope.parentOfChildId = targetBrandId;
                            $scope.currentBrandId = targetBrandId;

                            isChildBrand = false;
                            let index = parseInt(e.currentTarget.getAttribute("data-index")) - 1;
                            $(e.currentTarget).addClass("loading");
                            navigateToTarget(targetBrandId, index);
                        } else {
                            isChildBrand = true;
                            $scope.currentBrandId = targetBrandId;
                            updateView(targetBrandId, true, false, true);
                        }

                        $scope.currentBrandId = targetBrandId;
                        if ($scope.currentBrandId) {
                            $locationFilterMsg.css('display', 'block');
                        }

                        selectedCategory = {
                            targetId: targetBrandId,
                            targetName: targetBrandName,
                            targetParent: parentName,
                            index: index,
                            type: type,
                            activeJobsCount: activeJobsCount
                        };

                        try {
                            await getBrandActiveCategoryPositions();

                            const isChildEnterprise = $(this).hasClass('enterprise');

                            $scope.filterJobs('', false, false, isChildEnterprise);
                            $scope.getLocationsForMap('', isChildEnterprise);
                        } catch (error) {
                            console.error(error);
                        }

                        $navBar.removeClass("expanded");

                        if (!$navBar.hasClass("expanded")) {
                            if (selectedCategory && !_.isEmpty(selectedCategory)) {
                                if (selectedCategory.type !== "CHILD" && !isChildEnterprise) {
                                    navigateToTarget(selectedCategory.targetId, selectedCategory.index);
                                } else {
                                    $navbarHeaderName.html(selectedCategory.targetName);
                                    $(".brand-details .active-jobs-count").html(selectedCategory.activeJobsCount);
                                }
                            }

                            $('.header-select-btn').css('display', 'none');
                        }

                        CareerPortalDataBus.setBrandLevelId(targetBrandId);
                    }
                });

                $careerPortalNavbar.on('click', '.header-select-btn', function (e) {
                    e.stopPropagation();

                    $scope.filter.selectedBrands = [];
                    drawSelectedBrands();

                    var element = $(this).parent()[0];
                    let targetBrandId = element.getAttribute("data-brand-id");
                    let targetBrandName = element.getAttribute("data-brand-name");
                    let type = element.getAttribute("data-brand-type");

                    isChildBrand = false;

                    selectedCategory = {
                        targetId: targetBrandId,
                        targetName: targetBrandName,
                        targetParent: parentName,
                        type: type
                    };

                    try {
                        getBrandActiveCategoryPositions();

                        $scope.filterJobs();
                        $scope.getLocationsForMap();
                    } catch (error) {
                        console.error(error);
                    }

                    $navBar.removeClass("expanded");
                    $navbarHeaderSelectBtn.css('display', 'none');

                    updateURL();
                });

                $careerPortalNavbar.on('click', '.prev-btn', (e) => {
                    if (e.currentTarget.getAttribute("data-brand-type") != "CHILD") {
                        let targetBrandId = e.currentTarget.getAttribute("data-brand-id");
                        let index = parseInt(e.currentTarget.getAttribute("data-index"));
                        navigateToTarget(targetBrandId, index, true);
                        isChildBrand = false;
                    }
                    if (isMultipleLocationsModeFilterEnabled()) {
                        drawSelectedBrands();
                    }
                    checkNavigatorControls();
                });

                $careerPortalNavbar.on('click', '.next-btn', (e) => {
                    if (e.currentTarget.getAttribute("data-brand-type") != "CHILD") {
                        let targetBrandId = e.currentTarget.getAttribute("data-brand-id");
                        let index = parseInt(e.currentTarget.getAttribute("data-index"));
                        navigateToTarget(targetBrandId, index, true);
                        isChildBrand = false;
                    }
                    if (isMultipleLocationsModeFilterEnabled()) {
                        drawSelectedBrands();
                    }
                    checkNavigatorControls();
                });

                $careerPortalNavbar.on('click', '.return-btn', (e) => {
                    let targetBrandId = e.currentTarget.getAttribute("data-brand-id");
                    let index = undefined;

                    if (CareerPortalDataBus.getBasicInfo().id !== parseInt(targetBrandId)) {
                        index = 0;
                    }

                    navigateToTarget(targetBrandId, index, 'return');

                    isChildBrand = false;
                    if (isMultipleLocationsModeFilterEnabled()) {
                        drawSelectedBrands();
                    }
                    checkNavigatorControls();
                });

               $jobCard.on('click', '.job-item-content .select-compare-btn', function (e) {
                    e.preventDefault();
                    const $jobItemRef = $(e.target).closest('.job-item-content');
                    handleJobSelection($jobItemRef);
                });

                $(document).ready(() => {
                    $(document).on('click', '.compare-job-container .delete-icon', function (e) {
                        const $compareJobItemRef = $(e.target).closest('.compare-job-item-content');
                         handleJobSelection($compareJobItemRef);
                    });

                    $(document).on('click', '.compare-panel .cancel-button', function (e) {
                        closeComparisonPanel();
                    });

                    $(document).on('click', '.compare-panel .close-button', function (e) {
                        closeComparisonPanel();
                    });

                    $(document).on('click', '.compare-panel .compare-button', function (e) {
                         openComparisonResultPanel();
                    });

                    $(document).on('click', '.compare-panel .mobile-compare-button', function (e) {
                        openComparisonResultPanel();
                    });

                    $(document).on('click', '.compare-panel .reset-filters-btn', function (e) {
                        $scope.resetFilters();
                        renderComparisonPanel();
                    });

                    $(document).on('click', '.jobs-board-header .jobs-board-header-clear-btn', function (e) {
                        $scope.resetFilters();
                        $scope.showComparisonPanel && closeComparisonPanel();
                    });

                    $(document).on('click', '.jobs-board-header  .jobs-board-header-map-action', function (e) {
                        $scope.handleShowMap();
                    });

                    $(document).on('click touch', '.compare-panel .checkbox-icon', function (e) {
                        e.preventDefault();
                        const $jobItemRef = $(e.target).closest('.compare-job-item-content');
                        const jobId = $jobItemRef.data('job-id');
                        const job = $scope.allJobsSearchResult.find(job => job.id === jobId);

                        const isSelected = $scope.isJobSelected(job);
                        const $checkboxIcon = $jobItemRef.find('.checkbox-icon');
                        const $checkboxIconContainer = $jobItemRef.find('.compare-card-details');

                        updateCompareCheckboxUIOnMobile($checkboxIconContainer, $checkboxIcon, isSelected);
                        updateCompareSelectedJobsOnMobile(job, isSelected);
                        updateCheckboxesStatusOnMobile();
                        updateCompareButtonStatusOnMobile();
                    });

                    $(document).on('input', '.compare-panel #search_phrase', function (e) {
                        const searchPhrase = $(e.target).val().toLowerCase();

                        // Filter jobs based on the search phrase
                        $('.jobs-section .compare-job-item-content').each(function () {
                            const jobName = $(this).find('.compare-position-name').text().toLowerCase();
                            const jobLocation = $(this).find('.compare-job-location').text().toLowerCase();

                            // Check if the job matches the search criteria
                            $(this).toggle(jobName.includes(searchPhrase) || jobLocation.includes(searchPhrase));
                        });
                    });

                    $(document).on('click', '.comparison-result-panel .close-panel-button', function (e) {
                        closeComparisonResultPanel();
                    });

                    $(document).on('click', '.comparison-result-panel .apply-button', function (e) {
                        const $jobItemRef = $(e.target).closest('.actions');
                        const jobId = $jobItemRef.data('job-id');
                        const job = $scope.allJobsSearchResult.find(job => job.id === jobId);

                        const applyUrl = prepareJobApplyUrl(job);
                        $('.apply-button').attr('href', applyUrl);
                    });
                });

                $careerPortalCoverWrapper.on('click', '#search-icon', () => {
                    $('.cover-image-wrapper').addClass('auto-height');
                    $('.cover-image-inner, .cover-shadow, .overlay').addClass('fade-out');
                    $('.nav-row-mobile').addClass('d-none');
                    // Wait for the transition to complete before hiding the banner, overlay...
                    setTimeout(() => {
                        $('.cover-image-inner, .cover-shadow, .cover-image, .overlay').addClass('d-none');
                        $('.search-bar-container').addClass('show');
                    }, 500);
                });

                $careerPortalCoverWrapper.on('click', '#arrow-icon', () => {
                    $('.cover-image-wrapper').removeClass('auto-height');
                    $('.cover-image-inner, .cover-shadow, .overlay').removeClass('fade-out');
                    $('.cover-image-inner, .cover-shadow, .cover-image, .overlay').removeClass('d-none');
                    $('.nav-row-mobile').removeClass('d-none');
                    $('.search-bar-container').removeClass('show');
                });

                isChildBrand = false;
                backTo = [];

                var parent = CareerPortalDataBus.getBrandLevelId();
                var selectedCategory = {};
                var navigateToTarget = async function (targetBrandId, index, fromNavBtn) {
                    loadedJobs = 0;

                    if (!fromNavBtn) {
                        backTo.push(CareerPortalDataBus.getBrandLevelId());
                    } else if (fromNavBtn === 'return' && backTo.length > 0) {
                        backTo.pop();
                    }

                    let brandTree = CareerPortalDataBus.getBrandsTree();
                    let currentBrandLevelId = backTo.length > 0 ? backTo[backTo.length - 1] : CareerPortalDataBus.getBrandLevelId();
                    prev = null;
                    next = null;

                    if (index !== undefined) {
                        const currentBrandTree = brandTree[currentBrandLevelId];
                        if (currentBrandTree && currentBrandTree.brands) {
                            if (index > 0) {
                                prev = { id: currentBrandTree.brands[index - 1].id, index: index - 1 };
                            }
                            if (index < currentBrandTree.brands.length - 1) {
                                next = { id: currentBrandTree.brands[index + 1].id, index: index + 1 };
                            }
                        }
                    }

                    let tree;
                    if (brandTree[targetBrandId]) {
                        tree = brandTree[targetBrandId];
                    } else {
                        try {
                            tree = await CareerPortalAPI.getBrandChildrenDetails(targetBrandId, isPrivatePortal);
                            brandTree[targetBrandId] = tree;
                            CareerPortalDataBus.setBrandsTree(brandTree);
                        } catch (error) {
                            console.error(error);
                            return;
                        }
                    }

                    if (tree.type === 'ENTERPRISE') {
                        tree.parentActiveJobsCount = getTotalJobsForEnterprise({...tree});
                        enterpriseData.name = tree.name;
                        enterpriseData.active_jobs_count = tree.active_jobs_count;
                    }

                    let template = DispatcherServices.getNunjucks().render("modules/profiles/views/gp-career-portal-partials/side-nav-bar.tmpl.html", {
                        enterpriseChildrenDetails: tree,
                        parentBrand: backTo[backTo.length - 1],
                        next: next,
                        prev: prev,
                        basicInfo: CareerPortalDataBus.getBasicInfo()
                    });
                    $('.career-portal-navbar').html(template);
                    updateView(targetBrandId);
                    checkNavigatorControls();

                };

                var updateView = async function(targetBrandId, isChild, fromURL, isEnterpriseChild) {
                    if (!isChild) {
                        parent = targetBrandId;
                    }

                    CareerPortalDataBus.setBrandLevelId(targetBrandId);

                    if (!fromURL) {
                        try {
                            await getBrandActiveCategoryPositions();

                            const isEnterpriseChild = $(this).hasClass('enterprise');
                            $scope.filterJobs('', false, false, isEnterpriseChild);
                            await $scope.getLocationsForMap('', isEnterpriseChild);
                        } catch (error) {
                            console.error(error);
                        }
                    }

                    if ((isMobileOrSmallScreen() && $navBar.hasClass("expanded")) && CareerPortalDataBus.getBasicInfo() && CareerPortalDataBus.getBrandLevelId() == CareerPortalDataBus.getBasicInfo().id) {
                        $navbarHeaderSelectBtn.css('display', 'block');
                    } else {
                        $navbarHeaderSelectBtn.css('display', 'none');
                    }

                    checkNavigatorControls();
                    var $navBarHeaderH1 = $(".nav-bar-header h1");
                    if (isChild) {
                        if (!isMobileOrSmallScreen()) {
                            $(".nav-element").removeClass("highlighted");
                            $("#brand-" + targetBrandId).addClass("highlighted");

                            $navBarHeaderH1.addClass("out-of-focus");

                            $navBarHeaderH1.on("click", (e) => {
                                isChildBrand = false;

                                updateView(parent);
                                $navBarHeaderH1.removeClass("out-of-focus");
                                $(".nav-element").removeClass("highlighted");
                            })
                        } else {
                            $("#brand-" + targetBrandId).find('.select-btn').addClass("active");
                        }
                    } else {
                        $scope.parentOfChildId = targetBrandId;
                        $scope.currentBrandId = targetBrandId;
                        $navBarHeaderH1.off("click");
                    }

                    $('.career-portal-navbar .select-btn').css('display', 'none');
                    $careerPortalNavbarToggleNavMenu.css('display', 'none');
                };


                $scope.resetFilters = () => {
                    clearAllFilter();
                    $scope.applyFilters();
                    $scope.doDelayedSearch();
                };

                $scope.openComparisonPanel = () => {
                    !$scope.isMobileView && hideCompareBannerButton();
                    hideJobActionButtons();
                    showCompareSelectBtns();
                    $jobsBoardBody.addClass('show-compare-panel');
                    $('.card-details').addClass('compare-mode');
                    $scope.availableSlots = Array.from({ length: $scope.maxSelectedJobsForComparison }, (_, index) => ({
                        index: index + 1,
                        job: null,
                        occupied: false
                    }));
                    $scope.selectedJobsForComparison = [];
                    updateCompareButtonStatus();

                    renderComparisonPanel();
                    $scope.showComparisonPanel = true;
                };

                $scope.onApplyTalentPool = async () => {
                    const isPrivateLink = $state.current.isPrivateLink;
                    const baseUrl = (isPrivateLink ? '/internal/' : '') + $scope.basicInfo.slug;
                    const applyUrl = `${baseUrl}/apply/${$scope.talentPoolJob.id}${talentScoutCodeId ? `?talent_scout_code_id=${talentScoutCodeId}` : ''}`;
                    $('.join-talent-pool').attr('href', applyUrl);
                };

                const closeComparisonPanel = () => {
                    hideCompareSelectBtns();
                    !$scope.isMobileView && showCompareBannerButton();
                    showJobActionButtons();
                    $jobsBoardBody.removeClass('show-compare-panel');
                    $('.card-details').removeClass('compare-mode');
                    $scope.showComparisonPanel = false;
                    $('.compare-panel').fadeOut('300');

                    // Clear all selections
                    clearCompareJobsSelections();

                    updateCompareButtonStatus();
                    updateSelectBtnsStatus();
                    if ($scope.brand.settings.interactive_map_enabled) {
                        initMap();
                    }
                };

                const openComparisonResultPanel = async () => {
                    const selectedJobIds = $scope.selectedJobsForComparison.map((job) => job.id);

                    // Check if there are selected job IDs before making the API call
                    if (selectedJobIds.length > 0) {
                        try {
                            $scope.comparisonResultJobs = [];
                            let jobsToCompare  = await BrandAPI.compareJobs(selectedJobIds);
                            $scope.comparisonResultJobs = selectedJobIds.map(id => jobsToCompare.find(job => job.id === id));

                            if ($scope.comparisonResultJobs.length) {
                                $scope.showComparisonResultPanel = true;
                                renderComparisonResultPanel();
                                if ($scope.brand.settings.interactive_map_enabled) {
                                    let preparedCompareLocations = prepareCompareLocations();
                                    await initMap(true, preparedCompareLocations);
                                }
                            }
                        } catch (error) {
                            console.error('Error fetching comparison result:', error);
                        }
                    }
                };

                const closeComparisonResultPanel = () => {
                    $scope.showComparisonResultPanel = false;
                    $('.comparison-result-panel').remove();
                    closeComparisonPanel();
                };

                $scope.addToComparisonSlot = (job) => {
                    const emptySlot = findEmptySlot();
                    if (emptySlot) {
                        occupySlot(emptySlot, job);
                    }
                    updateCompareButtonStatus();
                };

                $scope.removeFromComparisonSlot = (job) => {
                    const occupiedSlot = findOccupiedSlot(job);
                    if (occupiedSlot) {
                        releaseSlot(occupiedSlot);
                    }
                    updateCompareButtonStatus();
                };
                const prepareCompareLocations = () => {
                    return $scope.comparisonResultJobs.reduce((comparedLocations, job) => {
                        return comparedLocations.concat(
                            job.job_locations.map(location => ({
                                lat: location.latitude,
                                lng: location.longitude
                            }))
                        );
                    }, []);
                };

                // Function to handle job selection
                $scope.toggleJobSelection = (job) => {
                    const index = findJobIndex(job);
                    if (index === -1) {
                        addSelectedJob(job);
                    } else {
                        removeSelectedJob(index, job);
                    }
                    updateSelectBtnsStatus();
                    renderComparisonPanel();
                };

                // Function to check if a job is selected
                $scope.isJobSelected = (job) => $scope.selectedJobsForComparison.includes(job);

                const prepareJobApplyUrl = (job) => {
                    const isPrivateLink = $state.current.isPrivateLink;
                    const baseUrl = (isPrivateLink ? '/internal/' : '') + $scope.basicInfo.slug;
                    let paramsSeparator = '?';

                    if ($scope.basicInfo.settings.application_mode === 'APPLY') {
                        const jobReferer = {
                            url: window.location.pathname + window.location.search,
                            group: {
                                id: $scope.basicInfo.id,
                                name: $scope.basicInfo.name
                            }
                        };

                        const redirectionParam = encodeURIComponent(JSON.stringify(jobReferer).replace(/'/g, "&apos;"));
                        const positionInfo = {
                            'Position': job.position,
                            'custom_position': job.aliasPosition
                        };

                        const userPosition = $filter('userPosition')(positionInfo);
                        const username = $filter('username')(userPosition);
                        let url = `${baseUrl}/job/${job.id}-${username}`;
                        if (redirectionParam) {
                            url += `${paramsSeparator}redirect=${redirectionParam}`;
                            paramsSeparator = '&';
                        }
                        if (talentScoutCodeId) {
                            url += `${paramsSeparator}talent_scout_code_id=${talentScoutCodeId}`;
                            paramsSeparator = '&';
                        }
                        if (utmSource) {
                            url += `${paramsSeparator}utm_source=${utmSource}`;
                        }

                        return url;
                    } else {
                        let url = `${baseUrl}/apply/${job.id}`;
                        if (talentScoutCodeId) {
                            url += `${paramsSeparator}talent_scout_code_id=${talentScoutCodeId}`;
                            paramsSeparator = '&';
                        }
                        if (utmSource) {
                            url += `${paramsSeparator}utm_source=${utmSource}`;
                        }
                        return url;
                    }
                };

                $scope.showJobAlertsModal = () => {
                    $modal({
                        controller: 'getJobAlertsModal',
                        templateUrl: '../modules/profiles/modals/get-job-alerts/get-job-alerts.modal.html',
                        show: true,
                        resolve: {
                            modalData: () => {
                                const selectedPositionsCodes = $scope.filter.selectedPositions.map(position => position.code);
                                const basicInfo = CareerPortalDataBus.getBasicInfo();

                                return {
                                    brand: basicInfo,
                                    positions_codes: selectedPositionsCodes,
                                    onSuccess: (res) => showJobAlertsSuccessAlert(basicInfo),
                                    onError: (err, email) => showJobAlertsErrorAlert(email, basicInfo),
                                };
                            },
                        },
                    });
                };

                const showJobAlertsSuccessAlert = (basicInfo) => {
                    hAlert({
                        title: $filter("translate")("A verification email has been sent to your email account"),
                        text: $filter("translate")("Click on the link to verify your subscription and start receiving ") + basicInfo.name + $filter("translate")(" job alerts"),
                        custom_class: 'gp-career-portal-alert'
                    }, null, null, null, '.h-gp-career-portal');
                };

                const showJobAlertsErrorAlert = (email, basicInfo) => {
                    hAlert({
                        title: $filter("translate")("Email already exists"),
                        text: `${email} ${$filter("translate")("email already have jobs alerts for")} ${basicInfo.name}`,
                        custom_class: 'gp-career-portal-alert',
                        button: {
                            'confirm_text': $filter("translate")("Update Job Alerts"),
                            'on_confirm': () => {
                            }
                        }
                    }, null, null, null, '.h-gp-career-portal');
                };

                $scope.showMultipleApplyModal = () => {
                    if ($scope.allJobsSearchResult.length === 0) {
                        return;
                    }
                    const { first_name: applicantFirstName, last_name: applicantLastName, utm_source: referrer, showLogin, code } = $stateParams;
                    const preparedData = prepareSearchParams();
                    let resetPasswordCode;

                    if (code && !hUser.isLoggedIn()) {
                        resetPasswordCode = code;
                    }

                    multipleApplyModal = $modal({
                        controller: 'gpMultipleApplyModal',
                        templateUrl: '../modules/profiles/modals/gp-multiple-apply/gp-multiple-apply.modal.html',
                        show: true,
                        resolve: {
                            modalData: () => ({
                                jobs: $scope.allJobsSearchResult,
                                userLatitude: $scope.filter.userLocation && ($scope.filter.userLocation.latitude || $scope.filter.userLocation.lat),
                                userLongitude: $scope.filter.userLocation && ($scope.filter.userLocation.longitude || $scope.filter.userLocation.lon),
                                applicantFirstName,
                                applicantLastName,
                                referrer,
                                resetPasswordCode,
                                showLogin,
                                brand: CareerPortalDataBus.getBasicInfo(),
                                searchParams: preparedData.searchParams,
                                talentScoutId: talentScoutCodeId || null,
                                onApplySuccess: (jobIds, status, isMultipleApply) => {
                                    jobApplyFactory.PrepareApplySuccessModal(jobIds, status, isMultipleApply).then((data)=>{
                                        $.extend($scope, data)
                                        jobApplyFactory.showApplySuccessModal();
                                        $scope.$digest();
                                    });
                                },
                            }),
                        },
                    });
                };

                $scope.showSocialLinksModal = () => {
                    $modal({
                        controller: 'getSocialLinksModal',
                        templateUrl: '../modules/profiles/modals/get-social-links/get-social-links.modal.html',
                        show: true,
                        resolve: {
                            modalData: function () {
                                return {
                                    basicInfo: CareerPortalDataBus.getBasicInfo()
                                };
                            }
                        }
                    });
                };

                $scope.showInteractiveMap = () => {
                    if (isMobileOrSmallScreen()) {
                        $scope.showMapOnMobile = !$scope.showMapOnMobile;
                        if ($scope.showMapOnMobile) {
                            $('.jobs-list').addClass('map-shown')
                            $('.jobs-board-header').addClass('map-shown')
                            $('.jobs-board-container').addClass('map-shown')
                            $('.map_container').css('display', 'block');

                            if($scope.mapLoaded){
                                $scope.getLocationsForMap();
                            } else {
                                initMap();
                            }
                        } else {
                            $('.jobs-list').removeClass('map-shown')
                            $('.jobs-board-header').removeClass('map-shown')
                            $('.jobs-board-container').removeClass('map-shown')
                            $('.map_container').css('display', 'none');
                        }
                    }
                };

                const clearLocationsTree = () => {
                    const parent = document.querySelector('.nav-bar-menu');
                    const navElements = parent ? parent.querySelectorAll('.nav-element[data-brand-id]') : [];

                    navElements.forEach(navElement => {
                        const parent = $('.nav-bar-menu');
                        const navElements = parent.find('.nav-element[data-brand-id]');
                        for (let i = 0; i < navElements.length; i++) {
                            const navElement = $(navElements[i]);
                            const btn = navElement.find('.select-btn');
                            btn.removeClass('active');
                            btn.text($filter("translate")("Select"));
                            btn.css('border-color', '#0088DDFF');
                            btn.css('color', '#0088DDFF');
                        }
                    });
                };

                const clearAllFilter = () => {
                    for (var category in $scope.filter.selectedCategories) {
                        $scope.filter.selectedCategories[category].selected = false;
                    }
                    for (var position in $scope.filter.selectedPositions) {
                        $scope.filter.selectedPositions[position].selected = false;
                    }
                    for (var brand in $scope.filter.selectedBrands) {
                        $scope.filter.selectedBrands[brand].selected = false;
                    }
                    for (const jobType of $scope.filter.selectedJobTypes) {
                        jobType.selected = false;
                    }
                    $scope.filter.selectedJobTypes = [];
                    $scope.filter.useLocation = false;
                    $scope.filter.search_phrase = "";
                    $scope.filter.postal_code = "";
                    $scope.filter.postal_code_radius = default_postal_code_radius;
                    $scope.filter.selectedCategories = [];
                    $scope.filter.selectedPositions = [];
                    $scope.filter.selectedBrands = [];
                    // re init brandTree
                    $scope.brandTree = JSON.parse(JSON.stringify($scope.InitialBrandTree));
                    clearLocationFilter();
                    syncScope();
                };

                const clearLocationFilter = () => {
                    CareerPortalDataBus.setBrandLevelId(CareerPortalDataBus.getBasicInfo().id);
                    $scope.currentBrandId = CareerPortalDataBus.getBrandLevelId();
                    $scope.parentOfChildId = CareerPortalDataBus.getBrandLevelId();
                    isChildBrand = false;
                    clearLocationsTree();
                    setTimeout(() => {
                        $locationFilterMsg.css('display', 'none');
                    }, 2000);
                    syncScope();
                };

                $scope.clearLocationClicked = () => {
                    clearLocationFilter();
                    $scope.filterJobs();
                    $scope.getLocationsForMap();
                };

                $scope.showNavBar = true;

                const prepareBrandsTreeFilter = (tree) => {
                    const brandTree = tree.brands.map(brand => ({
                        label: brand.external_business_name || brand.name,
                        hasChilds: brand.type !== 'CHILD',
                        id: brand.id
                    }));
                    return brandTree;
                };

                $scope.brandTree = prepareBrandsTreeFilter(CareerPortalDataBus.getBrandsTree()[$scope.parentOfChildId]);
                $scope.InitialBrandTree = JSON.parse(JSON.stringify($scope.brandTree));

                $scope.onSelectedLocationsChanged = (selected) => {
                    $scope.filter.selectedBrands = selected;
                    $scope.onFiltersChange();
                };

                $scope.onBrandsChange = (selected) => {
                    $scope.filter.selectedBrands = angular.copy(selected);
                    $scope.onFiltersChange();
                };

                $scope.onFiltersChange = () => {
                    $scope.filterJobs();
                    $scope.getLocationsForMap();
                };

                $scope.getBrandChildren = async (brand) => {
                    try {
                        const tree = await CareerPortalAPI.getBrandChildrenDetails(brand.id, isPrivatePortal);
                        return prepareBrandsTreeFilter(tree);
                    } catch (error) {
                        return Promise.reject(error);
                    }
                };

                const renderSideNavbarTmpl = (tree) => {
                    var template = DispatcherServices.getNunjucks()
                        .render("modules/profiles/views/gp-career-portal-partials/side-nav-bar.tmpl.html", {
                            enterpriseChildrenDetails: tree,
                            parentBrand: backTo[backTo.length - 1] || null,
                            next: next,
                            prev: prev,
                            basicInfo: CareerPortalDataBus.getBasicInfo()
                        });
                    $scope.showNavBar = true;
                    $('.career-portal-navbar').html(template);
                }

                var getBackToArrayOfParents = async function (parentId) {
                    try {
                        backTo = [];
                        while (true) {
                            let tree = await CareerPortalAPI.getBrandChildrenDetails(parentId, isPrivatePortal);
                            if (tree.group_id != tree.id) {
                                backTo.push(tree.group_id);
                                parentId = tree.group_id;

                            } else {
                                break;
                            }
                        }
                        return backTo;
                    } catch (error) {
                        return Promise.reject(error);
                    }
                };

                var handleTreeWithGroupId = async function (tree) {
                    backTo = await getBackToArrayOfParents(tree.group_id);
                    backTo.push(tree.group_id);

                    if (isMobileOrSmallScreen()) {
                        const childBrand = tree.brands.find(brand => brand.id == currentBrandId) || {};

                        tree["selected_child_brand"] = childBrand;

                        enterpriseData.name = tree.name;
                        enterpriseData.active_jobs_count = tree.active_jobs_count;
                        enterpriseData.selected_child = childBrand;
                    }

                    tree.parentActiveJobsCount = getTotalJobsForEnterprise(angular.copy(tree));
                    renderSideNavbarTmpl(tree);
                    await updateView(currentBrandId, true, true, isEnterpriseChild());
                };

                const handleBrandTypeChild = async (groupId, isPrivatePortal) => {
                    try {
                        const tree = await CareerPortalAPI.getBrandChildrenDetails(groupId, isPrivatePortal);

                        if (tree.group_id) {
                            await handleTreeWithGroupId(tree);
                        }
                    } finally {
                        $scope.$evalAsync();
                    }
                };

                //get the current brand id from url and view related jobs
                var currentBrandId = $stateParams.brand_id || $scope.parentOfChildId;
                if ((currentBrandId || $stateParams.group_id)) {
                    CareerPortalDataBus.setBrandLevelId(currentBrandId);
                    var brandTree = CareerPortalDataBus.getBrandsTree();
                    var parentId;

                    next = null;
                    prev = null;

                    var currentGroupId = $stateParams.group_id;


                    if (currentGroupId) {
                        isChildBrand = true;
                    }

                    getBrandActiveCategoryPositions()
                        .then(() => {
                            return CareerPortalAPI.getBrandChildrenDetails(currentBrandId, isPrivatePortal);
                        })
                        .then(tree => {
                            if (tree !== 'Invalid brand type child') {
                                return handleValidBrandTypeChild(tree);
                            } else if (currentGroupId) {
                                return handleBrandTypeChild(currentGroupId, isPrivatePortal);
                            }
                        })
                        .finally(() => {
                            $scope.$evalAsync();
                        })
                        .catch(error => {
                            console.error("Error:", error);
                        });
                }

                function handleValidBrandTypeChild(tree) {
                    if ($stateParams.brand_id) {
                        parentId = tree.group_id;
                        if (parentId) {
                            try {
                                getBackToArrayOfParents(parentId).the((data) =>{
                                    backTo = data;
                                    backTo.push(parentId);
                                });


                                if (tree.type === "ENTERPRISE") {
                                    tree.parentActiveJobsCount = getTotalJobsForEnterprise(angular.copy(tree));

                                    enterpriseData.name = tree.name;
                                    enterpriseData.active_jobs_count = tree.active_jobs_count;

                                    var selectedChild = {
                                        name: tree.name,
                                        active_jobs_count: tree.parentActiveJobsCount
                                    };

                                    enterpriseData.selected_child = selectedChild;
                                }

                                renderSideNavbarTmpl(tree);
                                brandTree[currentBrandId] = tree;
                                CareerPortalDataBus.setBrandsTree(brandTree);
                                updateView(currentBrandId, false, true, isEnterpriseChild());
                            } finally {
                                $scope.$evalAsync();
                            }
                        }
                    } else {
                        if ($scope.brand.settings.locations_filter_mode === 'NAVIGATION_TREE' || ($scope.brand.settings.locations_filter_mode === 'MULTIPLE_LOCATIONS' && isMobileOrSmallScreen())) {
                            renderSideNavbarTmpl(tree);
                        }
                        brandTree[currentBrandId] = tree;
                        CareerPortalDataBus.setBrandsTree(brandTree);
                        $('.career-portal-navbar .select-btn').css('display', 'none');
                        $careerPortalNavbarToggleNavMenu.css('display', 'none');
                        updateView(currentBrandId, false, true, isEnterpriseChild());
                    }
                }


                $scope.hideLocationsMap = () => {
                    $scope.showLocationMap = false;
                };

                $scope.clearSearch = () => {
                    $scope.filter.search_phrase = '';
                    $scope.doDelayedSearch();

                };

                $scope.onUseLocationChange =  () => {
                    if ($scope.filter.useLocation) {
                        setTimeout(() => {
                            $scope.filter.useLocation = false;
                            $scope.showLocationMap = false;
                            $scope.filterJobs();
                            if (isInteractiveMapEnabled()) {
                                initMap();
                            }
                        }, 2000);
                    } else {
                        $scope.filter.useLocation = true;
                        $scope.showLocationMap = true;

                        getUserLocation().then(() => {
                            try {
                                BrandAPI.getBrandPublicLocations(CareerPortalDataBus.getBasicInfo().id)
                                    .then((locations)=>{
                                        $scope.locations = locations;
                                        $scope.mapLocations = [];
                                        $scope.mapLocations.push([
                                            `<div class='location-popup'>
                                                <div class='details'>
                                                    <div class='name'>${$filter("translate")("My Location")}</div>
                                                    <div class='location'></div>
                                                </div>
                                            </div>`,
                                            $scope.filter.userLocation.latitude || $scope.filter.userLocation.lat,
                                            $scope.filter.userLocation.longitude || $scope.filter.userLocation.lon
                                        ]);

                                        for (const location of locations) {
                                            $scope.mapLocations.push([
                                                `<div class='location-popup'>
                                        <div class='icon-image' style='${$("#brand-image-thumb").html()}'></div>
                                        <div class='details'>
                                            <div class='name'>${$scope.brand.name}</div>
                                            <div class='location'>${location.Location.formatted_address || ''}</div>
                                        </div>
                                    </div>`,
                                                location.Location.latitude,
                                                location.Location.longitude
                                            ]);
                                        }

                                        if (isInteractiveMapEnabled()) {
                                            $scope.placeMarkerOnUserLocation();
                                        }

                                        $scope.$digest();
                                    });
                            } catch (error) {
                                console.error(error);
                            }
                        }).catch((e) => {
                            $scope.doDelayedSearch();
                        });
                    }
                };

                $('.career-portal-navbar .select-btn').css('display', 'none');
                $careerPortalNavbarToggleNavMenu.css('display', 'none');

                if ($stateParams.job_alert && $stateParams.job_alert === "open") {
                    $scope.showJobAlertsModal();
                }

                if ($scope.brand.settings.other_languages_enabled) {
                    $scope.isLanguageButtonShown = true;
                    initLanguagesSelector();
                }

                if (!!($stateParams.brand_id || $stateParams.group_id)) {
                    $locationFilterMsg.css('display', 'block');
                }

                if (typeof HThirdPartyManager !== 'undefined') {
                    HThirdPartyManager.register(HStoragePolicyManager.Categories.ANALYTICS, function() {
                        googleTagManagerTrackingService.init([currentBrandId]);
                    }, 'career_portal_tracking');
                }
            };

            $scope.placeMarkerOnUserLocation = () => {
                if ($scope.filter.userLocation) {
                    const LATITUDE = ($scope.filter.userLocation.latitude || $scope.filter.userLocation.lat);
                    const LONGITUDE = ($scope.filter.userLocation.longitude || $scope.filter.userLocation.lon);
                    googleMaps.map.setCenter({lat: LATITUDE, lng: LONGITUDE});
                    googleMaps.map.setZoom(15 - ((JOBS_SEARCH_LOCATION_RADIUS / 50) * 7.7));
                    googleMaps.placeMarker({lat: LATITUDE, lng: LONGITUDE}, googleMaps.map);
                }
            };

            $scope.getLocationsForMap = (keyChanged, isEnterpriseChild, center, radius, onInit, dontCenter) => {
                return new Promise((resolve, reject) => {
                    if (isInteractiveMapEnabled()) {
                        try {
                            const preparedData = prepareSearchParams(keyChanged, isEnterpriseChild, false, true, center, radius, onInit);
                            const mapSearchParams = preparedData.searchParams;
                            mapSearchParams['flow'] = 'CAREER_PORTAL';

                            if (!mapRequestLock) {
                                mapRequestLock = true;

                                CareerPortalAPI.searchJobsForMap(mapSearchParams)
                                    .then(mapLocationsResponse => {
                                        $scope.allMapLocations = mapLocationsResponse.data;
                                        if (MAX_SEARCH_LIMIT > $scope.allMapLocations.length) {
                                            $('.closet-max-jobs-msg').css('display', 'block');
                                        }
                                        if ($scope.mapLoaded) {
                                            addMarkers(null, null, dontCenter);
                                        }
                                        mapRequestLock = false;
                                        $scope.$evalAsync();
                                        resolve();
                                    })
                                    .catch(err => {
                                        console.error(err);
                                        mapRequestLock = false;
                                        reject(err);
                                    });
                            }
                        } catch (err) {
                            console.error(err);
                            mapRequestLock = false;
                            reject(err);
                        }
                    }
                });
            };

            let initMap = async (compareFlow, compareLocations, onInit) => {
                $scope.mapLoaded = false;
                try {
                    if (!compareFlow) {
                        await $scope.getLocationsForMap(null, null, null, null, onInit);
                    }
                    let mapLocations = compareFlow? compareLocations: $scope.allMapLocations;
                    let mapElementId = compareFlow ? 'compare_map' : 'jobs_map';
                    let mapElement = $('#' + mapElementId);
                    if (compareFlow) {
                        if ($scope.map['compareMap']) {
                            googleMaps.changeDefaultMap($scope.map['compareMap']);
                        }
                    } else {
                        if ($scope.map['jobsMap']) {
                            googleMaps.changeDefaultMap($scope.map['jobsMap']);
                        }
                    }

                    const zoom = 3;
                    googleMaps.initMap({
                        element: mapElement,
                        zoom,
                        center: mapLocations[0],
                        activeTheme: [],
                        scrollwheel: true,
                        minZoom: zoom - 2,
                        maxZoom: zoom + 8,
                        enableViewPortChanged: true,
                        viewPortChangedCallback: callback => {
                            if (!compareFlow && !$scope.isLoading && !$scope.placingMarkers) {
                                mapViewPortChangedHandler(callback);
                            }
                        }
                    }, (map)=> {
                        $scope.map['jobsMap'] = map;
                        $scope.map['compareMap'] = map;
                        addMarkers(compareFlow, compareLocations);
                        $scope.mapLoaded = true;
                        syncScope();
                    });
                } catch (error) {
                    console.error(error);
                }
            };

            const initLanguagesSelector = () => {
                $scope.defaultLang = $scope.currentLang = localize.getLang();
            };

            $scope.changeLanguage = (languageCode) => {
                let toLang = languageCode || $scope.defaultLang;
                HStorageManager.put({
                    storageLevel: HStorageManager.StorageLevels.COOKIES,
                    key: 'lang',
                    value: toLang,
                    codec: false,
                    expiryDays: 30
                });

                hEvent.track(
                    "language_change",
                    {
                        "to": toLang,
                        "from": $scope.currentLang,
                        "page": $state.current.name
                    },
                    () => {

                        $timeout(async () => {
                            if (hUser.isLoggedIn()) {
                                await SettingsAPI.saveUserLocale(toLang);
                                hRedirect(hGetCurrentUrl(toLang));
                            } else {
                                hRedirect(hGetCurrentUrl(toLang));
                            }
                        });
                    });
            };

            function addMarkers(compareFlow, compareLocations, dontCenter) {
                $scope.placingMarkers = true;
                googleMaps.googleServicePromise()
                    .then(function () {
                        googleMaps.clearMarkers();
                        googleMaps.clearMarkersCluster();
                        let clusterIconURL = '../images/gp-career-portal/cluster-icon.svg';
                        let singleIconUrl = '../images/gp-career-portal/single-location.svg';
                        if ($scope.allMapLocations || compareFlow) {
                            let mapLocations = compareFlow ? compareLocations: $scope.allMapLocations;
                            if (!dontCenter) {
                                googleMaps.foundBounds(mapLocations);
                            }
                            setTimeout(() => {
                                const mapCenter = googleMaps.map.getCenter();
                                if (mapCenter && typeof mapCenter.lat === 'function' && typeof mapCenter.lng === 'function') {
                                    centerLat = mapCenter.lat();
                                    centerLng = mapCenter.lng();
                                } else {
                                    centerLat = 0;
                                    centerLng = 180;
                                }

                                if (!dontCenter && centerLat === 0 && centerLng === 180 && mapLocations.length === 0 && $scope.filter.userLocation) {
                                    googleMaps.foundBounds([{lat: $scope.filter.userLocation.latitude || $scope.filter.userLocation.lat, lng:$scope.filter.userLocation.longitude || $scope.filter.userLocation.lon}]);
                                }
                                googleMaps.clusterMarkers(mapLocations, clusterIconURL, singleIconUrl)
                                $scope.placingMarkers = false;
                                syncScope();
                            }, 100);
                        } else {
                            $scope.placeMarkerOnUserLocation();
                        }
                    });
            }

            function mapViewPortChangedHandler(callback) {
                var currentCenter = callback.center;
                [currentCenter.lat, currentCenter.lng] = normalizeLatLong([currentCenter.lat, currentCenter.lng]);
                var radius = callback.radius;
                if (currentCenter.lat != centerLat && currentCenter.lng != centerLng) {
                    $scope.filterJobs('', true, false, false, currentCenter, radius);
                    $scope.getLocationsForMap('',  false, currentCenter, radius, false, true)
                }
            }

            init();

            //currentBrandId
            setCareerPortalFilters($stateParams.filters);

            /**
             * Private Functions
             */
            const getTotalJobsForEnterprise = (tree) => {
                const totalDifference = tree.brands.reduce((accumulator, brand) => accumulator + brand.active_jobs_count, 0);
                return tree.active_jobs_count - totalDifference;
            };

            var checkNavigatorControls = function() {
                let returnBtn = $('.return-btn');
                let navControls = $('.nav-controls');

                returnBtn.hide();
                navControls.hide();

                // Return btn logic
                let basicInfo = CareerPortalDataBus.getBasicInfo();
                if (basicInfo && basicInfo.type.includes('GP') && backTo.length > 0) {
                    returnBtn.show();
                }

                // Nav controls logic
                if (next || prev) {
                    navControls.show();
                }
            };

            const isEnterpriseChild = () => {
                return $stateParams.brand_id && $stateParams.group_id && $stateParams.brand_id === $stateParams.group_id;
            };

            $scope.checkFiltersSelected = () => {
                $scope.filtersSelectedFound =
                    ($scope.filter.selectedCategories?.length ||
                        $scope.filter.selectedPositions?.length ||
                        $scope.filter.selectedBrands?.length ||
                        $scope.filter.selectedJobTypes.length);
            }

            $scope.applyFilters = () => {
                $scope.checkFiltersSelected();
                $scope.filterJobs('');
                $scope.getLocationsForMap(false, '');
            }

            $scope.viewJobs = () => {
                $('.h-gp-career-portal').removeClass('simple-view-visible');
                $('.simplified-view').removeClass('visible');
                $(".h-gp-career-portal .simplified-view").css("height", "45vh");
            };

            $scope.simpleSearch = () => {
                $scope.filter.search_phrase = $scope.filter.simple_search_phrase;
                $scope.filterJobs('', true);
                $scope.getLocationsForMap(false, '');
                $scope.viewJobs();
            }

            $scope.showSettingsPanel = () => {
                $scope.showSettings = !$scope.showSettings;
            };

            $scope.toggleLocationFilter = () => {
                $scope.toggleBrandsSelector = !$scope.toggleBrandsSelector;
            }

            $scope.changeWithinDistance = () => {
                $scope.doDelayedSearch();
            }

            $scope.toggleApplyFilters = () => {
                $scope.closeMobileFilters();
                $scope.onFiltersChange();
            }

            // Helper functions
            function showCompareSelectBtns() {
                $('.job-item-content').addClass('auto-height');
                $('.select-container').addClass('show-select-container');
            }

            function hideCompareSelectBtns() {
                $('.job-item-content').removeClass('auto-height');
                $('.select-container').removeClass('show-select-container');
            }

            function showCompareBannerButton() {
                $('.cover-image-inner .compare-job').show();
            }

            function hideCompareBannerButton() {
                $('.cover-image-inner .compare-job').hide();
            }

            function hideJobActionButtons() {
                $('.actions').addClass('hidden-important');
            }

            const showJobActionButtons = () => {
                $('.actions').removeClass('hidden-important');
            };

            function findEmptySlot() {
                return $scope.availableSlots.find(slot => !slot.occupied);
            }

            function occupySlot(slot, job) {
                slot.job = job;
                slot.occupied = true;
            }

            const updateCompareButtonStatus = () => {
                $scope.$evalAsync(() => {
                    $scope.isCompareButtonDisabled = $scope.availableSlots.filter(slot => slot.occupied).length <= 1;

                    // Disable the button based on the updated status
                    const $compareButton = $('.compare-panel .compare-button');
                    const selectedJobsCount = $scope.selectedJobsForComparison.length;

                    // Set button text based on selected jobs count
                    $compareButton.text(selectedJobsCount === 0 ? 'Compare' : `Compare (${selectedJobsCount})`);

                    $compareButton.prop('disabled', $scope.isCompareButtonDisabled);

                    // Toggle the 'disabled' class based on the updated status
                    $compareButton.toggleClass('disabled', $scope.isCompareButtonDisabled);
                });
            };

            function findOccupiedSlot(job) {
                return $scope.availableSlots.find(slot => slot.occupied && slot.job.id === job.id);
            }

            function releaseSlot(slot) {
                slot.job = null;
                slot.occupied = false;
            }

            function findJobIndex(job) {
                return $scope.selectedJobsForComparison.findIndex(selectedJob => selectedJob.id === job.id);
            }

            function addSelectedJob(job) {
                if ($scope.selectedJobsForComparison.length < $scope.maxSelectedJobsForComparison  ) {
                    $scope.selectedJobsForComparison.push(job);
                    $scope.addToComparisonSlot(job);
                }
            }

            function removeSelectedJob(index, job) {
                $scope.selectedJobsForComparison.splice(index, 1);
                $scope.removeFromComparisonSlot(job);
            }

            function updateSelectBtnsStatus() {
                const isMaxSelected = $scope.selectedJobsForComparison.length >= $scope.maxSelectedJobsForComparison  ;

                // Disable all buttons with class 'select-compare-btn' except for the selected ones
                $('.select-compare-btn').prop('disabled', isMaxSelected).toggleClass('disable', isMaxSelected);

                // Enable only the selected buttons
                $scope.selectedJobsForComparison.forEach((selectedJob) => {
                    const btnSelector = `.select-compare-btn-${selectedJob.id}`;
                    $(btnSelector).prop('disabled', false).removeClass('disable');
                });
            }

            const clearCompareJobsSelections = () => {
                $scope.selectedJobsForComparison.forEach((job) => {
                    job.isSelected = false;

                    const selectBtn = $(`.select-compare-btn-${job.id}`);
                    selectBtn.removeClass('h-md-blue-solid-btn');
                    selectBtn.addClass('h-md-blue-outline-btn');
                    selectBtn.text($filter('translate')('Select'));
                });

                $scope.selectedJobsForComparison = [];
                $scope.availableSlots.forEach((slot) => {
                    slot.job = null;
                    slot.occupied = false;
                });
            };

            const renderComparisonPanel = () => {
                const filtersText = ($scope.appliedFiltersCount-1) > 1 ? $filter("translate")('filters applied') : $filter("translate")('filter applied');
                $scope.filtersCountText = `${($scope.appliedFiltersCount-1)} ${filtersText}`;

                const template = DispatcherServices.getNunjucks()
                    .render("modules/profiles/views/gp-career-portal-partials/job-compare-panel.tmpl.html", {
                        allJobs: $scope.allJobsSearchResult,
                        availableSlots: $scope.availableSlots,
                        appliedFiltersCount: $scope.filtersCountText,
                        basicInfo: $scope.basicInfo,
                        isMobileView: $scope.isMobileView,
                        searchPlaceholder: $scope.searchPlaceholder
                    });
                if (!$scope.showComparisonPanel) {
                    $('.compare-container').hide();
                }
                $('.compare-container').html(template);
                $('.compare-container').fadeIn(300);
            };

            const renderComparisonResultPanel = () => {
                const template = DispatcherServices.getNunjucks()
                    .render("modules/profiles/views/gp-career-portal-partials/jobs-comparison-result-panel.tmpl.html", {
                        comparisonResultJobs: $scope.comparisonResultJobs,
                        basicInfo: $scope.basicInfo
                    });
                $('.compare-container').html(template);
                updateCompensationTooltip('.compare-container', '.compare-compensation-details' );
            };

            const updateCompensationTooltip = function(mainClass, compensationContainerClass){
                let jobListContainer = $(mainClass);

                let compensationDetailsDivs = jobListContainer.find(compensationContainerClass);
                compensationDetailsDivs.each(function() {
                    let iTag = $(this).find('i');
                    let dataOriginalTitle = iTag.attr('data-original-title');
                    if (dataOriginalTitle) {
                        iTag.attr('title', dataOriginalTitle);
                    }

                });
            }

            const handleJobSelection = async ($jobItemRef) => {
                const jobId = $jobItemRef.data('job-id');
                const job = $scope.allJobsSearchResult.find(job => job.id === jobId);
                await $scope.toggleJobSelection(job);

                const selectBtn = $('.select-compare-btn-' + jobId);
                const isSelected = selectBtn.hasClass('h-md-blue-solid-btn');

                if (isSelected) {
                    // Change style to unselect
                    selectBtn.removeClass('h-md-blue-solid-btn').addClass('h-md-blue-outline-btn').text($filter("translate")("Select"));
                } else {
                    // Change style to selected
                    selectBtn.removeClass('h-md-blue-outline-btn').addClass('h-md-blue-solid-btn').text($filter("translate")("Unselect"));
                }
            };

            const updateCheckboxesStatusOnMobile = () => {
                const isMaxSelected = $scope.selectedJobsForComparison.length >= $scope.maxSelectedJobsForComparison;

                // Disable all checkboxes and toggle 'disable' class based on isMaxSelected
                $('.compare-job-container .checkbox-icon').prop('disabled', isMaxSelected).toggleClass('disable', isMaxSelected);

                // Enable only the selected checkboxes
                $scope.selectedJobsForComparison.forEach(selectedJob => {
                    const checkboxSelector = `#job-checkbox-${selectedJob.id}`;
                    $(checkboxSelector).prop('disabled', false).removeClass('disable');
                });
            };

            const updateCompareButtonStatusOnMobile = () => {
                const selectedJobsCount = $scope.selectedJobsForComparison.length;
                const compareButton = $('.mobile-compare-button');

                // Set button text based on selected jobs count
                compareButton.text(selectedJobsCount === 0 ? 'Compare' : `Compare (${selectedJobsCount})`);

                // Enable or disable the Compare button based on the selected jobs count
                compareButton.toggleClass('disabled', selectedJobsCount < 2);
            };

            const updateCompareCheckboxUIOnMobile = ($checkboxIconContainer, $checkboxIcon, isSelected) => {
                $checkboxIcon.toggleClass('selected', !isSelected);
                $checkboxIconContainer.toggleClass('selected', !isSelected);
            };

            const updateCompareSelectedJobsOnMobile = (job, isSelected) => {
                const index = findJobIndex(job);
                if (isSelected) {
                    $scope.selectedJobsForComparison.splice(index, 1);
                } else {
                    if ($scope.selectedJobsForComparison.length < $scope.maxSelectedJobsForComparison) {
                        $scope.selectedJobsForComparison.push(job);
                    }
                }
            }
        }]);
